<template>
  <div class="editPage" ref="editSpu" v-show="editProductModal">
    <Spin v-if="editPageLoaing" fix>数据加载中....</Spin>
    <!-- 头部工具条 -->
    <div class="topBtn">
      <div class="head-tabs">
        <RadioGroup v-model="pageEditTag" type="button">
          <template v-for="(tag, index) in tagList">
            <Radio
              v-if="!tag.powerKey || (tag.powerKey && permission[tag.powerKey])"
              :label="tag.value"
              :key="`tag-${index}`"
            >
              {{ tag.label }}
              <span v-if="tag.value == 'gpsrInfo'" class="gpsr-tips-icon">
                <Icon v-if="$common.isEmpty(pageGpsrInfo)" type="md-close" />
                <Icon v-else type="md-checkmark" />
              </span>
            </Radio>
          </template>
        </RadioGroup>
      </div>
      <div class="top-buttons">
        <div v-show="!isDisabled" style="display: inline-block;">
          <Button type="primary" :loading="waitingOk || spinShow" @click="beforeSave(false)"
            v-if="isSupplierTalg">暂存</Button>
          <Button type="primary" class="ml10" v-if="!initFinished || skuData.length > 0" :loading="waitingOk || spinShow"
            @click="beforeSave(true)">{{ isSupplierTalg ? '提交审批' : '保存' }}</Button>
          <Button class="ml10" type="warning" v-if="initFinished && skuData.length === 0" :loading="waitingOk || spinShow"
            @click="del">删除</Button>
        </div>
        <Button @click="turnBack" class="ml10">取消</Button>
      </div>
    </div>
    <Form ref="productInfo" class="edit-page-form" :model="productInfo" :label-width="110" label-position="right">
      <!-- 基础资料 -->
      <div class="tag-content-baseInfo tag-comtent-item" v-show="pageEditTag == 'baseInfo'">
        <div v-if="pageTagView['baseInfo']">
          <!-- 基本信息 -->
          <div style="display:flex">
            <div style="flex-direction:column">
              <div class="productsCont formItemLeft">
                <div class="productsTit padding-10">
                  <div id="basic">
                    基本信息
                  </div>
                </div>
                <div class="products-content padding-10">
                  <!-- 商品中文名称 -->
                  <Form-item label="中文名称" prop="cnName"
                    :rules="{ required: true, message: '商品中文名称' + '不能为空', trigger: 'blur' }">
                    <Input :disabled="isDisabled" :maxlength="1000" v-model.trim="productInfo.cnName"
                      placeholder="请输入商品中文名称"></Input>
                  </Form-item>
                  <!-- 商品英文名称 -->
                  <Form-item label="英文名称" prop="enName">
                    <Input :maxlength="1000" :disabled="isDisabled" v-model.trim="productInfo.enName"
                      placeholder="请输入商品英文名称"></Input>
                  </Form-item>
                  <!-- SPU/商品编码 -->
                  <Form-item label="SPU" prop="spu"
                    :rules="[{ required: true, message: 'SPU/商品编码' + '不能为空', trigger: 'blur' }, { validator: validateFormSku, trigger: 'blur' }]">
                    <Input :maxlength="100" disabled v-model.trim="productInfo.spu" placeholder="请输入SPU/商品编码"></Input>
                    <!-- :disabled="isDisabled" -->
                  </Form-item>
                  <!-- 分类 -->
                  <Form-item label="所属分类" prop="productCategoryId" v-if="!isSupplierTalg" :rules="[
                    { required: true, message: '请选择所属分类', trigger: 'change' }
                  ]">
                    <erpTreeSelect v-if="!isLoadInfo" :disabled="isDisabled" v-model="treeSelectCategoryValue"
                      :multiple="false" :normalizer="treeNormalizer" :options="productCategoryTree"
                      :default-expand-level="Infinity" placeholder="请选择所属分类" noResultsText="无匹配数据" @input="getTreeData" />
                  </Form-item>
                  <Form-item label="云卖分类" prop="ymsProductCategoryId" v-if="isSupplierTalg" class="classify_style"
                    :class="{ 'ivu-form-item-error': productInfo.ymsProductCategoryId === null }">
                    <treeSelect ref="productCategoryTree1" :disabled="isDisabled" :treeData="ymsMenuList"
                      @on-change="getYmsTreeData" filterable placeholder="请选择云卖分类" />
                    <div v-show="productInfo.ymsProductCategoryId === null" class="ivu-form-item-error-tip">
                      请选择云卖分类！
                    </div>
                  </Form-item>
                  <!-- 品牌 -->
                  <Form-item label="品牌" prop="productBrandId">
                    <dyt-select v-model.trim="productInfo.productBrandId" :disabled="isDisabled" :transfer="true" filterable
                      placeholder="请选择品牌">
                      <Option v-for="(item, index) in productBrandList" :key="index"
                        :class="{ productBrandRed: item.status === 0, hidden: item.status === 0 && item.productBrandId !== productInfo.productBrandId }"
                        :value="item.productBrandId">{{ item.name }}
                      </Option>
                    </dyt-select>
                  </Form-item>
                  <!-- 商品开发员 -->
                  <Form-item
                    label="开发员"
                    v-if="!isSupplierTalg"
                    prop="productDeveloperUserId"
                    :rules="[
                      { required: true, message: '请选择开发员', trigger: 'change' }
                    ]"
                  >
                    <dyt-select v-model="productInfo.productDeveloperUserId" :disabled="isDisabled">
                      <Option v-for="item in businessRoleTypeList" :value="item.userId" :key="item.userId">{{ item.userName }}</Option>
                    </dyt-select>
                  </Form-item>
                  <Form-item label="编织类型" v-if="isClothingType">
                    <dyt-select v-model="productInfo.braidType" :disabled="isDisabled">
                      <Option v-for="item in braidDataList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </dyt-select>
                  </Form-item>
                  <FormItem label="材质中文描述:" prop="materialCnDesc">
                    <!-- :rules="[
                          { required: true, message:'材质中文描述不能为空', trigger: 'blur' },
                          { required: true, message:'材质中文描述不能为空', trigger: 'change' }
                        ]" -->
                    <Input v-model="productInfo.materialCnDesc" placeholder="请输入" :maxlength="50" clearable
                      :disabled="isDisabled" />
                  </FormItem>
                  <FormItem label="材质英文描述:" prop="materialEnDesc">
                    <!-- :rules="[
                          { required: true, message:'材质英文描述不能为空', trigger: 'blur' },
                          { required: true, message:'材质英文描述不能为空', trigger: 'change' }
                        ]" -->
                    <Input v-model="productInfo.materialEnDesc" placeholder="请输入" :maxlength="50" clearable
                      :disabled="isDisabled" />
                  </FormItem>
                  <FormItem label="用途中文描述:" prop="usageCnDesc">
                    <!-- :rules="[
                          { required: true, message:'用途中文描述不能为空', trigger: 'blur' },
                          { required: true, message:'用途中文描述不能为空', trigger: 'change' }
                        ]"
                      > -->
                    <Input v-model="productInfo.usageCnDesc" placeholder="请输入" :maxlength="50" clearable
                      :disabled="isDisabled" />
                  </FormItem>
                  <FormItem label="用途英文描述:" prop="usageEnDesc">
                    <!-- :rules="[
                          { required: true, message:'用途英文描述不能为空', trigger: 'blur' },
                          { required: true, message:'用途英文描述不能为空', trigger: 'change' }
                        ]"
                      > -->
                    <Input v-model="productInfo.usageEnDesc" placeholder="请输入" :maxlength="50" clearable
                      :disabled="isDisabled" />
                  </FormItem>
                  <Form-item label="发货时效" prop="deliveryInterval" v-if="isSupplierTalg">
                    <dyt-select v-model="productInfo.deliveryInterval" :disabled="isDisabled">
                      <Option v-for="(item, index) in deliveryIntervalList" :value="item.value" :key="index">{{ item.name }}
                      </Option>
                    </dyt-select>
                  </Form-item>
                  <FormItem label="特殊标识:" prop="specialMarkList">
                    <dyt-select v-model="productInfo.specialMarkList" :disabled="isDisabled" :max-tag-count="1" multiple>
                      <Option v-for="item in specialMarkOption" :value="item.value" :key="item.value">{{ item.label
                      }}</Option>
                    </dyt-select>
                  </FormItem>
                </div>
              </div>
            </div>
            <!-- 图片信息 -->
            <productImageInfo
              :imagesInfoData.sync="multiLangImageData"
              :isDisabled="isDisabled"
              :instructionsPath.sync="productInfo.instructionsPath"
              :pictureTypeList.sync="productInfo.pictureTypeList"
              :spu="productInfo.spu"
              :pictureTypeData="pictureTypeData"
              :filenodeViewTargetUrl="filenodeViewTargetUrl"
            />
          </div>
          <!-- 报关信息 -->
          <div class="sxContent flex-30" v-if="!isSupplierTalg">
            <div class="productsTit padding-10">
              <div id="customs">
                报关信息
              </div>
            </div>
            <div class="products-content padding-10 form-item-flex-wrap">
              <!-- 报关中文名称 -->
              <Form-item label="报关中文名称" prop="cnHsName" :label-width="130"
                :rules="{ required: true, validator: hsNameMaxVerify, msg: '请输入报关中文名称', maxLength: 200, trigger: 'blur' }">
                <Input :disabled="isDisabled" v-model.trim="productInfo.cnHsName" placeholder="请输入报关中文名称" />
              </Form-item>
              <!-- 报关英文名称 -->
              <Form-item label="报关英文名称" prop="enHsName" :label-width="130"
                :rules="{ required: true, validator: enNameMaxVerify, msg: '请输入报关英文名称', maxLength: 200, trigger: 'blur' }">
                <Input :disabled="isDisabled" v-model.trim="productInfo.enHsName" placeholder="请输入报关英文名称" />
              </Form-item>
              <!-- 报关编码 -->
              <Form-item label="报关编码(HS Code)" prop="hsCode" :label-width="150"
                :rules="{ required: true, validator: hsCodeVerify, msg: '请输入报关编码(HS Code)', minLength: 10, maxLength: 10, trigger: 'blur' }">
                <Input :disabled="isDisabled" v-model.trim="productInfo.hsCode" placeholder="请输入报关编码（HS Code）"></Input>
              </Form-item>
            </div>
          </div>
          <!-- 商品属性 -->
          <div class="sxContent">
            <div class="productsCont">
              <div class="productsTit padding-10">
                <div id="basic">
                  商品属性
                </div>
              </div>
              <div class="products-content padding-20 attrForm">
                <Row>
                  <Col v-for="(attr, aIndex) in (productInfo.attributeFomNew && productInfo.attributeFomNew.attributeValueQOList || [])" :key="`attr-${aIndex}`">
                  <Form-item :label="`${attr.aliasName || ''}：`" :label-width="240"
                    :prop="`attributeFomNew.attributeValueQOList.${aIndex}.attributeValueIdList`"
                    :class="{ 'important-attribute': [2, '2'].includes(attr.isMandatory) }" :rules="[
                      { required: attr.isMandatory == 1, message: '必填项不能为空', trigger: 'blur', type: attr.type == 1 ? 'array' : 'number' },
                      { required: attr.isMandatory == 1, message: '必填项不能为空', trigger: 'change', type: attr.type == 1 ? 'array' : 'number' }
                    ]">
                    <dyt-select clearable v-model="attr.attributeValueIdList" :multiple="attr.type == 1"
                      style="width: 280px;" :disabled="isDisabled" filterable>
                      <Option v-for="(attrVal, vIndex) in attr.valueVOList" :value="attrVal.attributeValueId"
                        :key="`attrVal-${vIndex}`">{{ `${attrVal.cnValue}:${attrVal.enValue}` }}</Option>
                    </dyt-select>
                  </Form-item>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <!-- 质检标准 -->
          <div class="productsCont normalTop">
            <!-- v-if="treeSelectCategoryJson[treeSelectCategoryValue] && !$common.isEmpty(treeSelectCategoryJson[treeSelectCategoryValue].qualityClassificationId)" -->
            <div class="productsTit padding-10">
              质检标准
            </div>
            <div class="products-content padding-20">
              <div>
                <Form-item label="质检类型" prop="checkType" style="display: inline-block;">
                  <RadioGroup v-model="productInfo.checkType">
                    <Radio label="0" :disabled="isDisabled">免检</Radio>
                    <Radio label="2" :disabled="isDisabled">全检</Radio>
                    <Radio label="1" :disabled="isDisabled">抽检</Radio>
                  </RadioGroup>
                </Form-item>
                <Form-item
                  label="质检比例(%)"
                  prop="checkRate"
                  style="display: inline-block;"
                  :rules="{
                    validator: validateCheckRate,
                    min: 1,
                    max: 99,
                    point: 0,
                    msg: `请输入质检比例`,
                    trigger: 'change'
                  }"
                >
                  <Input :disabled="isDisabled || ![1, '1'].includes(productInfo.checkType)"
                    v-model.trim="productInfo.checkRate" placeholder="请输入质检比例" />
                </Form-item>
                <Form-item
                  label="应检最少数量"
                  prop="minCheckNum"
                  style="display: inline-block;"
                  :rules="{
                    validator: validateMinCheckNum,
                    min: 1,
                    point: 0,
                    msg: `请输入应检最少数量`,
                    trigger: 'change'
                  }"
                >
                  <Input
                    :disabled="isDisabled || [0, '0'].includes(productInfo.checkType)"
                    v-model.trim="productInfo.minCheckNum"
                    placeholder="请输入应检最少数量"
                  />
                </Form-item>
                <Form-item
                  label="新供应商强制全检"
                  prop="newSupplierCheck"
                  style="display: inline-block;"
                >
                  <Checkbox v-model="productInfo.newSupplierCheck" :disabled="isDisabled" />
                </Form-item>
                <Form-item
                  label="常规尺寸重量核验"
                  prop="basicSpecificationVerification"
                  style="display: inline-block;"
                >
                  <Checkbox v-model="productInfo.basicSpecificationVerification" :disabled="isDisabled" />
                </Form-item>
              </div>
              <qualityInspectionStandard
                v-if="!isLoadInfo"
                ref="qualityInspection"
                :product-id="productId"
                :disabled="isDisabled"
                :product-info="productInfo"
                :editProductModal="editProductModal"
                :product-category-list-data="productCategoryListData"
              />
            </div>
          </div>
          <!-- 商品描述 -->
          <div class="productsCont normalTop">
            <div class="productsTit padding-10">
              <div id="productDis">
                商品描述
              </div>
            </div>
            <div class="products-content padding-10 tabs-textmaterial">
              <div class="components-container">
                <Tabs v-model="langActiveTab" @on-click="langTabsSwitch" name="langTabName">
                  <TabPane v-for="(item, index) in languageTab" :label="item.label" :name="item.key"
                    :key="`${index}-${item.key}`" tab="langTabName" />
                </Tabs>
                <!-- <Button class="tabs-btnpos" size="small" @click="openSizeChart">生成尺码图</Button> -->
                <Dropdown transfer @on-click="openSizeChart" class="tabs-btnpos" trigger="click">
                  <Button size="small" type="primary">生成尺码图 <Icon type="ios-arrow-down"></Icon></Button>
                  <DropdownMenu slot="list">
                    <DropdownItem :name="1">通用尺码图</DropdownItem>
                    <DropdownItem :name="2">婴童尺码图</DropdownItem>
                    <DropdownItem :name="3">儿童尺码图</DropdownItem>
                    <DropdownItem :name="4">女鞋尺码图</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <Form-item :label-width="90" label="关键词：">
                  <local-tag-input style="width: 100%; display: inline-block" :disabled="isDisabled"
                    :tags="descriptionBOJson[langActiveTab]['keywords']" />
                </Form-item>
                <Tabs v-model="descActiveTab" type="card" @on-click="descTabsSwitch" name="descTabName">
                  <TabPane v-for="(desc, dIndex) in descriptionTab" :label="desc.label" :name="desc.key"
                    :key="`${dIndex}-${desc.key}`" tab="descTabName" />
                </Tabs>
                <div class="editor-container">
                  <UE :disabled="isDisabled" :content.sync="descriptionBOJson[langActiveTab][descActiveTab]"
                    :htmlStatus="false" v-show="initFinished && descActiveTab !== 'textDescription'"
                    id="productInfo.description.edit" :config=config ref="descdomeue" :isVisible.sync="isVisible"
                    @childType="getChildType" />
                  <Input v-show="initFinished && descActiveTab === 'textDescription'" style="width: 100%;" type="textarea"
                    :autosize="{ minRows: 26, maxRows: 26 }" :maxlength="65536"
                    v-model="descriptionBOJson[langActiveTab][descActiveTab]" placeholder="请输入..." :disabled="isDisabled" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 多属性资料 -->
      <div class="tag-comtent-item" v-show="pageEditTag == 'multiattribute'">
        <productMultiattribute
          v-if="pageTagView['multiattribute']"
          ref="productMultiattributeRef"
          :productInfo.sync="productInfo"
          :skuData.sync="skuData"
          :skuPropertyList.sync="skuPropertyList"
          :isDisabled="isDisabled"
          :pageEditTag="pageEditTag"
          :pageTagView="pageTagView"
          :customProductTagList="customProductTagList"
          :productStatus="productStatus"
          :treeSelectCategoryJson="treeSelectCategoryJson"
          :textTalg="textTalg"
          :columnSizeOrModel="columnSizeOrModel"
          :initFinished="initFinished"
          :isOldData="isOldData"
          :sizeList="sizeList"
          :colorList="colorList"
          @edit-sku-image="editSkuImage"
          @edit-distribution="editDistribution"
          @edit-assemble="editAssemble"
          @bind-size-group="bindSizeGroupNo"
        />
      </div>
      <!-- 生产资料 -->
      <div class="tag-content-productionInfo tag-comtent-item" v-show="pageEditTag == 'productionInfo'">
        <div v-if="pageTagView['productionInfo']">
          <!-- 采购要求信息 -->
          <div class="sxContent flex-70" v-if="!isSupplierTalg">
            <div class="productsTit padding-10">
              <div id="customs">
                采购要求信息
              </div>
            </div>
            <div class="products-content purchase-content padding-10">
              <FormItem label="水洗唛成分:" prop="washedLabel" :label-width="90">
                <Input class="textarea-resize-none" v-model="productInfo.washedLabel" placeholder="请输入水洗唛成分，最多300字符"
                  type="textarea" :maxlength="300" clearable :autosize="{ minRows: 2, maxRows: 4 }"
                  :disabled="isDisabled" />
              </FormItem>
              <!-- <FormItem label="水洗唛养护说明:" prop="washedLabelMaintainDesc" :label-width="95">
                <Input class="textarea-resize-none" v-model="productInfo.washedLabelMaintainDesc" placeholder="请输入水洗唛养护说明，最多300字符"
                  type="textarea" :maxlength="300" clearable :autosize="{ minRows: 2, maxRows: 4 }"
                  :disabled="isDisabled" />
              </FormItem> -->
              <FormItem label="水洗唛养护说明:" prop="washableLabelInfoId" :label-width="95">
                <dytSelect v-model="productInfo.washableLabelInfoId" :disabled="isDisabled" placeholder="请选择水洗唛养护说明">
                  <Option
                    v-for="(item, mIndex) in washableDataList"
                    :key="`${item.id}-${mIndex}`"
                    :value="item.id"
                    :label="item.maintenanceInstructions"
                  />
                </dytSelect>
              </FormItem>
              <FormItem label="" prop="washableLabelInfoId" :label-width="0">
                <div v-if="washableDataJson[productInfo.washableLabelInfoId]" class="washable-label-view">
                  <Poptip trigger="hover" title="" placement="right-start" v-if="washableDataJson[productInfo.washableLabelInfoId].picturePath">
                    <img
                      :src="`${filenodeViewTargetUrl}${washableDataJson[productInfo.washableLabelInfoId].picturePath}`"
                      @click="previewImg(`${filenodeViewTargetUrl}${washableDataJson[productInfo.washableLabelInfoId].picturePath}`)"
                      class="washable-pic-view"
                      title="点击预览图片原图"
                    />
                    <div slot="content">
                      <img
                        :src="`${filenodeViewTargetUrl}${washableDataJson[productInfo.washableLabelInfoId].picturePath}`"
                        class="washable-max-pic-view"
                      />
                    </div>
                  </Poptip>
                  <div class="washable-pdf-view ml5" v-if="washableDataJson[productInfo.washableLabelInfoId].pdfPath">
                    <span @click="previewWashedPdf(washableDataJson[productInfo.washableLabelInfoId].pdfPath)" title="点击预览PDF文件">
                      {{ washableDataJson[productInfo.washableLabelInfoId].pdfName }}
                    </span>
                  </div>
                </div>
              </FormItem>
              <Form-item prop="washedLabelPdfPath" :label-width="120">
                <div slot="label">
                  <div>水洗唛文件：</div>
                  <div>(PDF/JPG/PNG)</div>
                </div>
                <dytUpload v-show="false" ref="washedUploadRef" file-name="files" :show-upload-list="false"
                  accept="application/pdf,image/jpg,image/jpeg,image/png" :before-upload="washedUploadBefore"
                  :action="uploadFilesUrl" />
                <div class="washed-operate">
                  <Poptip trigger="hover" placement="left" v-if="!$common.isEmpty(productInfo.washedLabelPdfPath)" transfer>
                    <div class="washed-image-content">
                      <img :src="pdfFirstImgPreview" @click="previewWashedPdf(productInfo.washedLabelPdfPath)" />
                      <Spin fix v-if="isWashedUploadLoading"></Spin>
                    </div>
                    <div class="washed-image-preview-content" slot="content">
                      <img :src="pdfFirstImgPreview" @click="previewWashedPdf(productInfo.washedLabelPdfPath)" />
                    </div>
                  </Poptip>
                  <span class="click-text-underline" @click="opentCheckFile"
                    v-if="!isDisabled && $common.isEmpty(productInfo.washedLabelPdfPath)">
                    点击上传
                    <Spin fix v-if="isWashedUploadLoading"></Spin>
                  </span>
                  <template v-if="!$common.isEmpty(productInfo.washedLabelPdfPath)">
                    <span class="click-text-underline" @click="previewWashedPdf(productInfo.washedLabelPdfPath)">预览</span>
                    <span class="click-text-underline" @click="opentCheckFile" v-if="!isDisabled">更换</span>
                    <span class="click-text-underline" v-if="!isDisabled" @click="removeWashedPdf">删除</span>
                  </template>
                </div>
              </Form-item>
              <Form-item label="水洗唛word文件：" prop="washedLabelWordPath" :label-width="130">
                <uploadSampleFile v-model="productInfo.washedLabelWordFile" :disabled="isDisabled"
                  accept-error-txt="文件格式不对，请上传格式为 docx、doc 的 word文档格式文件" :file-max-size="30" :upload-props="{
                    multiple: false,
                    accept: [
                      'application/msword',
                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                    ]
                  }" />
              </Form-item>
              <Form-item label="纸样文件：" prop="patternFile" :label-width="120">
                <uploadSampleFile v-model="productInfo.patternFile" :disabled="isDisabled"
                  accept-error-txt="文件格式不对，请上传格式为 pdf、excel、prj 的文件" :file-max-size="30" :upload-props="{
                    multiple: true,
                    accept: [
                      '.prj',
                      'application/pdf',
                      'application/vnd.ms-excel',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    ]
                  }" />
              </Form-item>
              <FormItem label="SPU生产要求:" prop="outerPackageRequirement"
                :rules="{ validator: validateOutPack, trigger: 'change' }" :label-width="90">
                <Input class="textarea-resize-none" v-model.trim="productInfo.outerPackageRequirement"
                  placeholder="请输入SPU生产要求，最多200字符" type="textarea" clearable :autosize="{ minRows: 2, maxRows: 4 }"
                  :disabled="isDisabled" />
              </FormItem>
              <Form-item label="生产尺码图：" :label-width="120">
                <div class="washed-operate">
                  <Poptip trigger="hover" placement="left" v-if="!$common.isEmpty(dimensionPlan)">
                    <div class="washed-image-content">
                      <img :src="dimensionPlan" @click="previewImg(dimensionPlan)" />
                    </div>
                    <div class="washed-image-preview-content" slot="content">
                      <img :src="dimensionPlan" @click="previewImg(dimensionPlan)" />
                    </div>
                  </Poptip>
                  <img v-else :src="placeholderSrc"
                    style="width: 46px; height: 46px; object-fit: cover; vertical-align: middle; cursor: pointer;">
                  <template v-if="!$common.isEmpty(dimensionPlan)">
                    <span class="click-text-underline" @click="previewImg(dimensionPlan)">预览</span>
                    <span class="click-text-underline" v-if="!isDisabled" @click="removePlanImg">删除</span>
                  </template>
                </div>
              </Form-item>
              <Form-item label="其他附件：" prop="attachmentPath" :label-width="120">
                <uploadSampleFile
                  v-model="productInfo.attachmentPath"
                  :disabled="isDisabled"
                  :file-max-size="5"
                  :max-file-number="5"
                  :showSuffix="true"
                  :upload-props="{
                    multiple: true,
                    accept: [],
                  }"
                />
              </Form-item>
            </div>
          </div>
          <!-- 物料资料 -->
          <div class="sxContent products-content flex-70">
            <div class="productsTit padding-10">
              <div id="customs">
                物料资料
              </div>
            </div>
            <materialData ref="materialRefDemo" :productData="productInfo" :disabled="isDisabled"
              :modelVisible="!spinShow" />
          </div>
          <!-- 其他费用 -->
          <div class="sxContent products-content flex-70">
            <div class="productsTit padding-10">
              <div id="customs">
                其他费用
              </div>
            </div>
            <laPaFeeType ref="refLaPaFeeType" :productData="productInfo" :disabled="isDisabled" :modelVisible="!spinShow" />
          </div>
          <!-- 工艺要求说明 -->
          <div class="sxContent products-content flex-70">
            <div class="productsTit padding-10">
              <div id="customs">
                工艺要求说明
              </div>
            </div>
            <processRequire ref="processRequireInstructionsRef" :productData="productInfo" :disabled="isDisabled" :modelVisible="!spinShow" />
          </div>
          <!-- 车缝工价 -->
          <!-- <div class="sxContent products-content flex-70">
            <div class="productsTit padding-10">
              <div id="customs">
                车缝工价
              </div>
            </div>
            <sewingLaborRrate ref="sewingLaborRrateDemo" :productData="productInfo" :disabled="isDisabled"
              :modelVisible="!spinShow" />
          </div> -->
          <!-- 工艺要求 -->
          <!-- <div class="sxContent products-content flex-70">
            <div class="productsTit padding-10">
              <div id="customs">
                工艺要求
              </div>
            </div>
            <technologicalRequire ref="technologicalDemo" :productData="productInfo" :disabled="isDisabled"
              :modelVisible="!spinShow" />
          </div> -->
          <!-- 二次工艺要求 -->
          <!-- <div class="sxContent products-content flex-70">
            <div class="productsTit padding-10">
              <div id="customs">
                二次工艺要求
              </div>
            </div>
            <twiceCraftRequire ref="twiceCraftDemo" :productData="productInfo" :disabled="isDisabled"
              :modelVisible="!spinShow" />
          </div> -->
          <!-- 生产尺码图 -->
          <!-- <div class="sxContent products-content flex-70">
            <div class="productsTit padding-10">
              <div id="customs">
                生产尺码图
              </div>
            </div>
            <frameHoppingData ref="frameHoppingDemo" :productData="productInfo" :disabled="isDisabled"
              :modelVisible="!spinShow" :sizeList="sizeList" />
          </div> -->
        </div>
      </div>
      <!-- 销售链接 -->
      <div class="tag-comtent-item" v-show="pageEditTag == 'salesLink'">
        <salesLinkView
          v-if="isDisabled && pageTagView['salesLink']"
          :module-data="salesViewData"
          :module-visible="pageEditTag == 'salesLink' && isDisabled"
        />
      </div>
      <!-- GPSR资料 -->
      <div class="tag-comtent-item" v-show="pageEditTag == 'gpsrInfo'">
        <gpsrView
          v-if="editProductModal && pageTagView['gpsrInfo']"
          :module-data="gpsrViewData"
          @refreshList="refreshList"
        />
      </div>
    </Form>
    <keep-alive>
      <Modal v-model="modifyProductGoodsImgModal" v-if="renderModifyProductGoodsImgModal"
        title="变参 SKU 多语言独立图套配置面板" width="900px" :mask-closable="false">
        <!-- 顶部语言Tab -->
        <div class="sku-img-modal-tabs">
          <span
            v-for="tab in skuImgLangTabs"
            :key="tab.value"
            :class="['sku-img-tab', skuImgActiveTab === tab.value ? 'active' : '']"
            @click="skuImgActiveTab = tab.value; skuImgSpuFilterLang = tab.value"
          >
            {{ tab.label }}
            <em v-if="skuImageSetList.filter(s => s.language === tab.value && (s.images || []).length > 0).length > 0" class="sku-img-tab-count">
              {{ skuImageSetList.filter(s => s.language === tab.value).reduce((n, s) => n + (s.images || []).length, 0) }}
            </em>
          </span>
        </div>
        <!-- 当前操作语种提示 + 同步选项 -->
        <div class="sku-img-modal-sync-bar">
          <span>当前操作语种：<strong>{{ skuImgActiveLangLabel }}</strong></span>
          <Checkbox v-model="isSynchroAllSkcModel[skuImgActiveTab]" style="margin-left:20px;">应用到相同 model 的 SKU</Checkbox>
          <Checkbox v-model="isSynchroAllSkcColor[skuImgActiveTab]" style="margin-left:10px;">应用到相同 color 的 SKU</Checkbox>
        </div>
        <!-- 图套区域 -->
        <div class="sku-img-modal-suite" :loading="skuImageSetLoading">
          <!-- 图套标签行 -->
          <div class="sku-img-set-bar">
            <div class="sku-img-set-tags">
              <span
                v-for="imgSet in currentLangImageSets"
                :key="imgSet.productGoodsImageSetId"
                :class="['sku-img-set-tag', (currentActiveSet && currentActiveSet.productGoodsImageSetId === imgSet.productGoodsImageSetId) ? 'active' : '']"
                @click="switchImageSet(imgSet.productGoodsImageSetId)"
              >
                {{ imgSet.setName }}
                <em v-if="imgSet.setType" class="sku-set-type-badge" :style="{ background: getSetTypeBadgeColor(imgSet.setType) }">{{ getSetTypeLabel(imgSet.setType) }}</em>
              </span>
            </div>
            <span class="sku-img-add-set-btn" @click="openAddSetModal">+ 新增图套</span>
          </div>
          <!-- 当前图套图片列表 -->
          <div class="sku-img-set-content">
            <div
              v-for="(imgPath, index) in currentSetImages"
              :key="`set-img-${index}-${imgPath}`"
              style="width:100px;height:100px;"
              class="product-upload-list"
            >
              <img :src="filenodeViewTargetUrl + imgPath">
              <div class="product-upload-list-cover" style="padding-top:50px;">
                <Icon class="ml10" title="设为主图" type="ios-home-outline"
                  @click.native.stop="setSetPrimaryImg(imgPath)"></Icon>
                <Icon class="mr10" title="删除" type="ios-trash-outline"
                  @click.native.stop="removeSetImg(imgPath)"></Icon>
              </div>
            </div>
            <template v-for="(file, index) in uploadList">
              <div v-if="file.status !== 'finished'" class="product-upload-list" style="width:100px;height:100px;" :key="index">
                <Progress v-if="file.showProgress" :percent="file.percentage"></Progress>
              </div>
            </template>
            <dytUpload
              file-name="files"
              ref="uploadProductGoodsImg"
              :headers="uploadFilesHeader"
              :show-upload-list="false"
              :max-size="uploadFilesMaxSize"
              :on-exceeded-size="uploadExceedSizeModal"
              :format="['jpg', 'png', 'gif']"
              :on-error="uploadFilesErrorModal"
              :on-success="uploadFilesSuccessModal"
              :on-format-error="handleFormatErrorModal"
              :action="uploadFilesUrl"
              multiple
              :before-upload="beforeUploadModal"
              type="drag"
              style="display: inline-block;width:100px;"
            >
              <div style="width: 100px;height:100px;line-height: 100px;text-align:center;">
                <div style="font-size:18px;color:#bbb;">+</div>
                <div style="font-size:12px;color:#bbb;line-height:1.2;">上传网图</div>
              </div>
            </dytUpload>
            <!-- 无图套时提示 -->
            <div v-if="currentLangImageSets.length === 0" class="sku-img-no-set-tip">
              暂无图套，请点击「+ 新增图套」创建
            </div>
          </div>
          <!-- 删除图套 / 编辑图套 -->
          <div class="sku-img-set-del-bar" v-if="currentActiveSet">
            <span class="sku-img-edit-set-link" @click="openEditSetModal(currentActiveSet)">
              编辑图套名称/类型
            </span>
            <span class="sku-img-del-set-link" style="margin-left:14px;" @click="delImageSet(currentActiveSet)">
              删除图套 [{{ currentActiveSet.setName }}]
            </span>
          </div>
        </div>
        <!-- SPU公共图库 -->
        <div class="sku-img-modal-spu">
          <div class="sku-img-modal-spu-header">
            <span>从 SPU 公共图库快速添加图片</span>
            <div class="sku-img-spu-lang-filter">
              <!-- <span
                :class="['spu-filter-tag', skuImgSpuFilterLang === 'common' ? 'active' : '']"
                @click="skuImgSpuFilterLang = 'common'"
              >通用</span> -->
              <span
                v-for="tab in skuImgLangTabs"
                :key="`filter-${tab.value}`"
                :class="['spu-filter-tag', skuImgSpuFilterLang === tab.value ? 'active' : '']"
                @click="skuImgSpuFilterLang = tab.value"
              >{{ tab.shortLabel }}</span>
            </div>
          </div>
          <div class="sku-img-modal-spu-list">
            <template v-if="skuImgSpuImages.length > 0">
              <div
                v-for="(img, index) in skuImgSpuImages"
                :key="`spu-${index}-${img.path}`"
                style="width:90px;height:90px;"
                class="product-upload-list"
              >
                <img :src="filenodeViewTargetUrl + img.path">
                <div class="product-upload-list-cover" style="padding-top:50px;">
                  <Button @click.stop="addImgToCurrentSet(img.path)" style="outline:none;box-shadow:none;" size="small" type="text">添加至SKU</Button>
                </div>
              </div>
            </template>
            <div v-else class="product-spu-list" style="width:90px;height:90px;">
              <Icon type="image" size="30" color="#d4d4d4"></Icon>
              <p>未添加图片</p>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="confirModifyProductGoodsImg" type="primary">保存并同步架构</Button>
          <Button @click="uploadModalCancel">取消</Button>
        </div>
      </Modal>
    </keep-alive>

    <!-- 新增/编辑图套弹框 -->
    <Modal
      v-model="skuAddSetModal"
      :title="skuAddSetIsEdit ? '编辑图套信息' : '新建语言专属图套'"
      width="420px"
      :footer-hide="true"
      @on-cancel="skuAddSetModal = false"
    >
      <div class="sku-add-set-modal-body">
        <!-- 图套显示名称 -->
        <div class="sku-add-set-row">
          <label class="sku-add-set-label">图套显示名称</label>
          <Input
            v-model="skuAddSetName"
            placeholder="如：冬款质感主图"
            :maxlength="30"
            class="sku-add-set-input"
          />
          <div v-if="skuAddSetNameErr" class="sku-add-set-err">{{ skuAddSetNameErr }}</div>
        </div>
        <!-- 图套类型定义 -->
        <div class="sku-add-set-row">
          <label class="sku-add-set-label">图套类型定义</label>
          <div class="sku-add-set-type-list">
            <label
              v-for="opt in skuSetTypeOptions"
              :key="opt.value"
              :class="['sku-set-type-option', skuAddSetType === opt.value ? 'active' : '']"
              @click="skuAddSetType = opt.value"
            >
              <span class="sku-set-type-radio">
                <span v-if="skuAddSetType === opt.value" class="sku-set-type-radio-dot"></span>
              </span>
              <span class="sku-set-type-badge-lg" :style="{ background: opt.color }">{{ opt.label }}</span>
            </label>
          </div>
        </div>
        <!-- 底部按钮 -->
        <div class="sku-add-set-footer">
          <Button @click="skuAddSetModal = false">取消</Button>
          <Button type="primary" style="margin-left:10px;" @click="confirmAddImageSet">{{ skuAddSetIsEdit ? '确认修改' : '确认创建' }}</Button>
        </div>
      </div>
    </Modal>

    <!-- 表格弹框 -->
    <table-edit :isVisible.sync="isVisible" :type="type" :languageType="langActiveTab"
      @tableEditcontent="tableEditcontent"></table-edit>

    <!-- 返回顶部 -->
    <!-- <BackTop></BackTop> -->
    <!-- 添加组装模态框 -->
    <addAssembleModal ref="addAssembleModal" @addTabData="addTabData" :openType="openType"
      :editAssembleIndex="editAssembleIndex"></addAssembleModal>

    <!-- 通用、女鞋尺码图 -->
    <sizeChart :chartModalVisible.sync="chartModalVisible" :productCategoryListData="productCategoryListData"
      :productInfo="productInfo" :sizeTypeFar="sizeTypeFar" :colorList="colorList" :sizeList="sizeList"
      :planType="planType" :skuPropertyList="skuPropertyList" @getSizePicture="getSizePicture"
      @insetDescription="insetDescription" :editStatus="editStatus" />

    <!-- 婴童、儿童尺码图 -->
    <child-size-chart :isVisible.sync="childVisible" :childType="planType" :productInfo="productInfo"
      @getSizePicture="getSizePicture" :productCategoryListData="productCategoryListData"
      @insetDescription="insetDescription" :editStatus="editStatus" />
    <!-- 分销编辑 -->
    <editDistribution :modelVisible.sync="distributionVisible" :distribution-info="distributionInfo"
      @distributionConfirm="distributionConfirm" />
    <!-- 绑定尺码组弹窗 -->
    <bindSizeGroupModal :modelVisible.sync="bindSizeGroupVisible" :moduleData="bindSizeModuleData"
      @confirmModal="editAttributes" />
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import api from '@/api/api';
import UE from '@/components/ue/ue.vue';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
import productMixin from '@/components/mixin/product_mixin';
// import { getToken } from '@/utils/cookie';
import addAssembleModal from './addAssembleModal';
import productData from '@/views/productCenter/components/productCenter/staticData/productData';
import sizeChart from '@/views/productCenter/components/productCenter/sizeChart/sizeChart';
import childSizeChart from '@/views/productCenter/components/productCenter/sizeChart/childSizeChart';
import tableEdit from '@/components/tableEdit/index.vue';
import 'viewerjs/dist/viewer.css'
import qualityInspectionStandard from './qualityInspectionStandard';
// import washedSginModal from './washedSginModal';
import bindSizeGroupModal from './bindSizeGroupModal';
import editDistribution from './editDistribution';
import uploadSampleFile from './uploadSampleFile';
import productImageInfo from './productImageInfo';
import productMultiattribute from './productMultiattribute';
import materialData from './materialData';
// import sewingLaborRrate from './sewingLaborRrate';
// import technologicalRequire from './technologicalRequire';
// import twiceCraftRequire from './twiceCraftRequire';
// import frameHoppingData from './frameHoppingData';
import laPaFeeType from './laPaFeeType';
import processRequire from './processRequire';
import salesLinkView from './salesLinkView';
import gpsrView from './gpsrView';
import { imageTypeData } from '@/utils/constantData';

// import { checkWashedData } from './productData';

const showTabKey = ['baseInfo', 'productionInfo'];

export default {
  mixins: [Mixin, tableMixin, productMixin],
  components: {
    UE,
    addAssembleModal,
    sizeChart,
    childSizeChart,
    tableEdit,
    editDistribution,
    qualityInspectionStandard,
    uploadSampleFile,
    productImageInfo,
    productMultiattribute,
    materialData,
    // sewingLaborRrate,
    // technologicalRequire,
    // twiceCraftRequire,
    // frameHoppingData,
    // washedSginModal,
    laPaFeeType,
    processRequire,
    bindSizeGroupModal,
    salesLinkView,
    gpsrView
  },
  // 分类  品牌  特性标签  详情数据id
  props: {
    editProductModal: {
      type: Boolean,
      default: false
    },
    productCategoryListData: {
      type: Array,
      default: () => {
        return []
      }
    },
    productCategoryIds: {
      type: Array,
      default: () => {
        return []
      }
    },
    productBrandList: {
      type: Array,
      default: () => {
        return []
      }
    },
    productTagList: {
      type: Array,
      default: () => {
        return []
      }
    },
    productId: {
      type: String,
      default: ''
    },
    ymsMenuList: {
      type: Array,
      default: () => {
        return []
      }
    },
    editStatus: {
      type: String,
      default: ''
    },
    originalCategoryData: {
      type: Array,
      default: () => {
        return []
      }
    },
    productGoodsListDictionary: {
      type: Object,
      default: () => {
        return {}
      }
    },
    productGoodsListDictionaryData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    otherData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    var self = this;
    return {
      editPageLoaing: false,
      washableDataList: [],
      washableDataJson: {},
      pictureTypeData: imageTypeData,
      pageEditTag: 'baseInfo',
      pageTagView: {},
      uploadOtherAttachment: api.uploadAttachment, // 商品其他附件上传 API
      tagList: [
        { label: '基础资料', value: 'baseInfo' },
        { label: '多属性资料', value: 'multiattribute' },
        { label: '生产资料', value: 'productionInfo' },
        { label: '销售链接', value: 'salesLink', powerKey: 'sales' },
        { label: 'GPSR资料', value: 'gpsrInfo' }
      ],
      bindSizeGroupVisible: false,
      bindSizeModuleData: {},
      distributionVisible: false,
      specificationsObj: {},
      distributionInfo: {},
      qualityProductArray: [],
      childVisible: false,
      planType: null,
      isWashedUploadLoading: false,
      // 编织类型：0-针织 1-梭织 2-毛织
      braidDataList: [
        { label: '针织', value: 0 },
        { label: '梭织', value: 1 },
        { label: '毛织', value: 2 }
      ],
      validateCol: {
        isWeight: [],
        isLength: [],
        isWidth: [],
        isHeight: [],
        isSuggestPrice: []
      },
      languageTab: [
        { key: 'EN', label: '英语' },
        { key: 'GER', label: '德语' },
        { key: 'FRA', label: '法语' },
        { key: 'SPN', label: '西班牙语' },
        { key: 'IT', label: '意大利语' },
        { key: 'POR', label: '葡萄牙语' },
        { key: 'CN', label: '中文' },
        { key: 'PLN', label: '波兰语' }
      ],
      descriptionTab: [
        { key: 'description', label: '复杂描述' },
        { key: 'simpleDescription', label: '简易描述' },
        { key: 'textDescription', label: '纯文本描述' },
        { key: 'highlightDescription', label: '亮点描述' },
        { key: 'packageDescription', label: '包裹描述' },
        { key: 'mobileDescription', label: '移动端描述' }
      ],
      langActiveTab: 'EN',
      descActiveTab: 'description',
      oldActiveLang: 'EN', // 语言类型切换时给变量赋值
      oldActiveDesc: 'description', // 描述类型切换时给变量赋值
      descriptionBOJson: {},
      productStatus: productData.productStatus,
      initGetTreeData: true,
      treeSelectCategoryValue: '',
      treeSelectCategoryJson: {},
      businessRoleTypeList: [],
      editIndex: -1, // 修改货品图片(货品下标)
      minWidth: 200, // 表格制定列最小宽度
      waitingOk: false, // 点击确认按钮是否需要显示loading遮罩
      initFinished: false, // 是否初始化完成
      customProductTagList: [], // 这个标签列表包含自定义标签
      productInfoPrototype: null, // 当前商品信息原型
      modifyProductGoodsImgModal: false, // 修改货品图片模态窗口显示隐藏标识
      renderModifyProductGoodsImgModal: false, // 渲染修改货品图片模态窗口
      checkedProductGoodsImages: [], // 已被选中的货品图片
      productGoodsImageArray: {}, // 临时存放上传图片的对象，按语言分组 { common: ['path',...], en: [...] }
      productGoodsPrimaryImage: null, // 货品主图
      skuImgActiveTab: 'common', // SKU图片弹框当前激活语言tab
      skuImgSpuFilterLang: 'common', // SPU图库语言筛选
      isSynchroAllSkcModel: { common: false, en: false, fr: false, de: false, ru: false, nl: false }, // 应用到相同model的SKU（按语言区分）
      isSynchroAllSkcColor: { common: false, en: false, fr: false, de: false, ru: false, nl: false }, // 应用到相同color的SKU（按语言区分）
      // 图套相关
      skuImageSetList: [], // 当前SKU的图套列表（按语言+图套组织）
      skuImageSetLoading: false, // 图套加载中
      skuActiveSetId: {}, // 当前各语言激活的图套id，{ common: id, en: id, ... }
      skuAddSetModal: false, // 新增/编辑图套弹框
      skuAddSetIsEdit: false, // true=编辑模式 false=新增模式
      skuAddSetEditTarget: null, // 编辑模式下的目标图套对象
      skuAddSetName: '', // 新增/编辑图套名称
      skuAddSetType: '1', // 新增/编辑图套类型（1网图 2非实拍自修图 3实拍自修图）
      skuAddSetNameErr: '', // 图套名称验证提示
      // 图套类型选项
      skuSetTypeOptions: [
        { value: '1', label: '网图', color: '#f90' },
        { value: '2', label: '非实拍自修', color: '#19be6b' },
        { value: '3', label: '实拍自修', color: '#19be6b' }
      ],
      uploadList: [], // 上传文件列表
      filenodeViewTargetUrl: self.$store.state.erpConfig.filenodeViewTargetUrl, // filenode根路径
      uploadFilesList: [],
      isUploading: false,
      uploadFilesLoading: false,
      uploadFilesUrl: api.upload_files + '?basePath=/product', // 上传url
      uploadFilesMaxSize: 10240, // 上传文件大小上线（kb）
      uploadMaxLength: 20, // 一次最多选中20个图片上传
      uploadFilesTime: null,
      uploadFilesCalLback: () => { },
      skuPropertyList: [], // 商品多属性列表
      config: { // 富文本编辑器 配置
        initialFrameWidth: null,
        initialFrameHeight: 500,
        serverUrl: api.product_ueditor_enter,
        wordCount: false
      },
      productCategoryTree: [ // 商品分类树
        {
          title: '全部',
          expand: true,
          productCategoryId: 'productCategoryId1',
          disabled: true,
          children: []
        }
      ],
      specificationColorList: [ // 规格颜色
        '#169BD5', '#009900', '#763EAF', '#CC0033', '#FF9900', '#999999', '#33CC99', '#663300'
      ],
      salesViewData: {},
      // gpsr 信息
      gpsrViewData: {},
      // 属性信息
      attributeFom: {
        attributeValueQOList: [],
        productCategoryId: '',
        productId: ''
      },
      productInfo: { // 产品信息
        materialCnDesc: '',
        materialEnDesc: '',
        usageCnDesc: '',
        usageEnDesc: '',
        productId: '',
        braidType: null,
        type: 1,
        cnName: null,
        enName: null,
        spu: null,
        cnHsName: null,
        enHsName: null,
        // description: '',
        descriptionBOList: [],
        hsCode: null,
        checkType: '0',
        checkRate: '0',
        minCheckNum: null,
        newSupplierCheck: false,
        basicSpecificationVerification: false,
        productBrandId: null,
        productCategoryId: null,
        ymsProductCategoryId: null,
        productImages: [],
        washedLabel: "", // 水洗唛成分
        // washedLabelMaintainDesc: '', // 水洗唛养护说明
        washableLabelInfoId: '',
        patternFile: '', // 纸样文件
        attachmentPath: '', // 其他附件
        instructionsPath: '', // 附件说明书path多个逗号隔开
        washedLabelWordFile: {}, // 水洗唛WORD 文件
        washedLabelWordPath: '', // 水洗唛WORD路径
        washedLabelWordName: '', // 水洗唛WORD名称
        productGoodsMaterialInfoVOList: [], // 物料信息
        laPaApiProductTechnologyVOList: [], // 工艺信息
        machiningRate: null, // 工序(车缝工价)-加工倍率
        productProcessVOList: [], // 工序信息
        productManufactureVOList: [], // 尺码信息(跳码表)
        washedLabelPdfPath: null,
        washedLabelPdfName: null,
        outerPackageRequirement: '', //  生产要求
        productGoodsList: [
          {
            productGoodsId: null,
            sku: null,
            ean: null,
            upc: null,
            isbn: null,
            width: 0,
            height: 0,
            length: 0,
            weight: 0,
            status: 1,
            suggestPrice: 0,
            samplePrice: 0,
            sampleFreight: 0,
            productGoodsTags: [],
            productGoodsImages: [],
            productGoodsSpecifications: [],
            productTypeListValue: ['01'],
            productionRequirement: '', // sku 生产要求
            isAssemble: false, // 是否组装
            editStatus: false, // 是否重新编辑
            productGoodsAssembles: [], // 组装信息
            embryonicClothSku: null, // 胚衣SKU
            embryonicClothDescription: null, //  胚衣描述
            printingImagePath: null, // 印花图案URL
          }
        ],
        operationType: 1, // 操作类型 0 暂存 1 提交
        deliveryInterval: 1,
        attributeFomNew: {
          attributeValueQOList: [],
          productCategoryId: '',
          productId: ''
        },
        specialMarkList: [],
      },
      specialMarkOption: [
        {
          value: '0',
          label: '抽真空'
        },
      ],
      deliveryIntervalList: [
        {
          value: 1,
          name: '1天'
        },
        {
          value: 2,
          name: '2天'
        },
        {
          value: 3,
          name: '3天'
        },
        {
          value: 4,
          name: '4天'
        },
        {
          value: 5,
          name: '5天'
        },
        {
          value: 6,
          name: '6天'
        },
        {
          value: 7,
          name: '7天'
        }
      ],
      skuData: [], // 货品数据
      editAssembleIndex: null, // 变参组装信息  当前编辑的下表
      openType: null, // 1 普通商品  2 变参商品
      categoryList: [], // 类目
      sizeChartdata: [],
      sizeChartColumns: [],
      classifyTalg: 'edit', // 记录在编辑页面云卖分类的状态： look -- 查看状态， edit-- 编辑状态， change -- 切换其他云卖分类模板
      templateObj: {},
      editObj: {},
      sizeJsonData: {},
      hideSizeChart: true,
      editor: null,
      oldAttrChange: false,
      selectedValue: '',
      colorList: [],
      sizeList: [],
      visible: false,
      chartModalVisible: false,
      commodiAttr: {
        laPaProductVariQuotationList: []
      },
      categoryChange: false,
      sizeTypeFar: null,
      productTypeFar: '',
      spinShow: true,
      isLoadInfo: true,
      firstProductInfo: {},
      isOldData: false,
      columnSizeOrModel: '',
      isVisible: false,
      type: null,
      pdfFirstImgPreview: '',
      pageGpsrInfo: {},
      pageProductGoodsId: [],
      multiLangImageData: [],
    };
  },
  watch: {
    pageEditTag: {
      immediate: true,
      deep: true,
      handler (val) {
        if (this.$common.isEmpty(val) || this.pageTagView[val]) return;
        if (this.$common.isUndefined(this.pageTagView[val])) {
          this.$set(this.pageTagView, val, true);
        } else {
          this.pageTagView[val] = true;
        }
      }
    },
    // 监听多文本输入
    initFinished(n) {
      if (n) {
        this.$nextTick(() => {
          this.editor = this.$refs['descdomeue'].editor;
          let userInfo = this.$store.state.erpConfig.userInfo;
          this.editor.addListener('ready', () => {
            this.editor.execCommand('serverparam', {
              'basePath': 'product-service',
              'userId': userInfo.merchantId + ',' + userInfo.userId
            })
          })
          this.$nextTick(() => {
            let content = this.descriptionBOJson[this.langActiveTab] && this.descriptionBOJson[this.langActiveTab][this.descActiveTab];
            this.editor.setContent(content);
          })
        })
      }
    },
    checkedProductGoodsImages(n, o) { // 如果不勾选图片那么切换主图
      if (this.checkedProductGoodsImages.indexOf(this.productGoodsPrimaryImage) === -1) {
        this.productGoodsPrimaryImage = this.checkedProductGoodsImages[0] || null;
      }
    },
    productGoodsPrimaryImage(n, o) { // 勾选主图时如果没有选择那么默认勾选上
      if (this.checkedProductGoodsImages.indexOf(n) === -1) {
        this.checkedProductGoodsImages.push(n);
      }
    },
    // 监听窗口显示隐藏,隐藏时重置数据
    editProductModal: {
      immediate: true,
      deep: true,
      handler(n) {
        if (n) { // 初始化数据
          this.categoryChange = false;
          this.isOldData = false;
          this.spinShow = true;
          this.$set(this.gpsrViewData, 'productId', this.productId);
          this.$set(this.gpsrViewData, 'productGoodsListDictionary', this.productGoodsListDictionaryData);
          this.$set(this.gpsrViewData, 'permission', this.permission);
          this.pageGpsrInfo = {};
          // 商品其他附件上传 API
          this.uploadOtherAttachment = `${api.uploadAttachment}/${this.productId}`;
          // 获取商品详情
          this.axios.get(api.productInfo_detail + this.productId).then(response => {
            if (response.data.code === 0) {
              let productInfo = response.data.datas;
              productInfo.newSupplierCheck = productInfo.newSupplierCheck == 1;
              productInfo.basicSpecificationVerification = productInfo.basicSpecificationVerification == 1;
              this.pageProductGoodsId = (productInfo.productGoodsList || []).map(m => m.productGoodsId);
              this.getGpsrInfo(this.pageProductGoodsId);
              this.$set(productInfo, 'washedLabelWordFile', {});
              if (!this.$common.isEmpty(productInfo.washedLabelWordPath)) {
                productInfo.washedLabelWordFile.fileName = productInfo.washedLabelWordName || productInfo.washedLabelWordPath;
                productInfo.washedLabelWordFile.fileUrl = productInfo.washedLabelWordPath;
              }
              const url = productInfo.washedLabelPdfPath;
              if (!this.$common.isEmpty(url)) {
                this.isWashedUploadLoading = true;
                const suffix = url.substring(url.lastIndexOf('.'), url.length);
                if (suffix.toLocaleLowerCase() == '.pdf') {
                  this.$common.getPdfRes({
                    pdfUrl: `./filenode/s${url}`,
                    pageNumber: 1,
                    scale: 10
                  }).then(img => {
                    this.pdfFirstImgPreview = img;
                  }).finally(() => {
                    this.isWashedUploadLoading = false;
                  })
                } else {
                  this.pdfFirstImgPreview = `./filenode/s${url}`;
                  this.isWashedUploadLoading = false;
                }
              }
              this.firstProductInfo = this.deepCopy(response.data.datas)
              this.initCategoryTree(productInfo.productCategoryId);
              this.$set(this.attributeFom, 'productCategoryId', productInfo.productCategoryId);
              this.$set(this.attributeFom, 'productId', productInfo.productId);
              // 销售链接数据
              this.salesViewData = {
                productGoodsList: productInfo.productGoodsList || [],
                list: productInfo.productGoodsPlatformUrls || []
              };
              // 获取分类属性值
              this.getAttributeData(productInfo, true);
              if (this.isSupplierTalg) {
                if (productInfo.ymsProductCategoryId) {
                  this.initYmsCategoryTree(productInfo.ymsProductCategoryId);
                  if (this.isDisabled) {
                    this.handlerTemplate(productInfo.productSizeList, productInfo.ymsProductCategoryId);
                    this.classifyTalg = 'look';
                  } else {
                    // 判断当前的商品是否已经过尺码模板
                    if (productInfo.sizeJson === null) {
                      this.classifyTalg = 'change';
                      this.getTemplateData(productInfo.ymsProductCategoryId);
                    } else {
                      this.classifyTalg = 'edit';
                      this.handlerTemplate(productInfo.productSizeList, productInfo.ymsProductCategoryId);
                      this.sizeJsonData = JSON.parse(productInfo.sizeJson);
                    }
                  }
                }
              }
              this.$nextTick(() => {
                this.checkOldData();
                this.initProductInfo(productInfo);
                this.reloadSkuColumn();
                this.getSizeList().then(() => {
                  this.disabledTreeItem();
                });
                this.loadPicture();
                setTimeout(() => {
                  this.initFinished = true;
                  this.initProductGoods(productInfo.productGoodsList);
                  /* if (this.skuPropertyList.length == 0) {
                    this.addColorSize();
                  } */
                }, 100)
                this.$set(this.gpsrViewData, 'productInfo', productInfo);
                this.delayTabShow();
              });
              this.isLoadInfo = false;
            } else {
              this.delayTabShow();
            }
          }).catch(() => {
            this.delayTabShow();
          });
          this.$parent.$parent.productId = null;
          this.$refs.editSpu.scrollTop = 0;
          this.customProductTagList = this.deepCopy(this.productTagList);
        } else {
          this.locationErrorInput('baseInfo');
          this.isLoadInfo = true;
          this.spinShow = true;
          this.delayTabShow(true);
        }
      }
    },
    renderModifyProductGoodsImgModal(n, o) {
      if (n) {
        this.$nextTick(() => {
          this.uploadList = this.$refs.uploadProductGoodsImg.fileList;
        });
      }
    },
    skuPropertyList: {
      handler(data) {
        if (this.classifyTalg === 'edit') {
          if (data.length > 0) {
            data.map((item) => {
              if (item.name === '尺码') {
                item.values.map((ele) => {
                  this.sizeChartdata.push(Object.assign({}, this.editObj, { sizeCode: ele }));
                });
              }
            });
            this.sizeChartdata = this.uniqueFunc(this.sizeChartdata, 'sizeCode');
          }
        } else if (this.classifyTalg === 'change') {
          this.sizeChartdata = [];
          if (data.length > 0) {
            data.map((item) => {
              if (item.name === '尺码') {
                item.values.map((ele) => {
                  this.sizeChartdata.push(Object.assign({}, { size: ele }, this.templateObj));
                });
              }
            });
          }
        }
      },
      deep: true
    },
    'productInfo.checkType': {
      deep: true,
      handler(val) {
        if ([0, '0'].includes(val)) {
          this.$set(this.productInfo, 'checkRate', '0');
          this.$set(this.productInfo, 'minCheckNum', null);
          return;
        }
        if ([1, '1'].includes(val)) {
          const rate = Number(this.productInfo.checkRate);
          const lastRate = this.$common.isEmpty(rate) ? '1' : rate > 1 && rate < 100 ? Math.floor(rate).toString() : '1';
          this.$set(this.productInfo, 'checkRate', lastRate);
          return;
        }
        if ([2, '2'].includes(val)) {
          this.$set(this.productInfo, 'checkRate', '100');
        }
      }
    },
    isUploading(val) {
      val && this.uploadFilesListHand();
    },
    /** 当子组件同步 skuData 时，确保 productInfo.productGoodsList 保持一致 */
    skuData: {
      deep: true,
      handler(val) {
        if (this.$common.isEmpty(val)) return;
        const newStr = JSON.stringify(val);
        const oldStr = JSON.stringify(this.productInfo.productGoodsList);
        if (newStr !== oldStr) {
          this.$set(this.productInfo, 'productGoodsList', this.deepCopy(val));
        }
      }
    },
    /**
     * 监听 multiLangImageData 变化，同步到 productInfo.productImages（SKU弹框数据源）
     * productImageInfo 上传/删除/排序图片后，SKU弹框的图库随之更新
     */
    multiLangImageData: {
      deep: true,
      handler(val) {
        if (this.$common.isEmpty(val)) return;
        const newProductImages = val.map(group => ({
          language: group.language,
          images: (group.images || []).map(img => ({ ...img }))
        }));
        const newStr = JSON.stringify(newProductImages);
        const oldStr = JSON.stringify(this.productInfo.productImages);
        if (newStr !== oldStr) {
          this.$set(this.productInfo, 'productImages', newProductImages);
        }
      }
    }
  },
  beforeCreate() {

  },
  created() {
    this.editPageLoaing = true;
    this.textInit();
    this.productInfoPrototype = this.deepCopy(this.productInfo);
    this.$common.promiseAll([
      this.getCommodityDeveloper, // 获取开发员
      this.getColorList, // 获取颜色数据
      this.getWashableList, // 获取水洗唛数据
    ]).finally(() => {
      this.editPageLoaing = false;
    });
  },
  computed: {
    uploadFilesHeader() {
      return {
        ...this.$store.getters.erpRequestHeaders,
        ...this.$store.getters.dytRequestHeaders
      }
    },
    /** SKU图片弹框语言 tab 列表 */
    skuImgLangTabs() {
      return [
        { value: 'common', label: '通用', shortLabel: '通用' },
        { value: 'en', label: '英语 (EN)', shortLabel: 'EN' },
        { value: 'fr', label: '法语 (FR)', shortLabel: 'FR' },
        { value: 'de', label: '德语 (DE)', shortLabel: 'DE' },
        { value: 'ru', label: '俄语 (RU)', shortLabel: 'RU' },
        { value: 'nl', label: '荷兰语 (NL)', shortLabel: 'NL' }
      ];
    },
    /** 当前激活语言标签显示文本 */
    skuImgActiveLangLabel() {
      const tab = this.skuImgLangTabs.find(t => t.value === this.skuImgActiveTab);
      return tab ? tab.label : this.skuImgActiveTab;
    },
    /** SPU图库按语言筛选后的图片列表 */
    skuImgSpuImages() {
      const allImages = [];
      (this.productInfo.productImages || []).forEach(group => {
        (group.images || []).forEach(img => {
          allImages.push({ path: img.path, language: group.language });
        });
      });
      if (this.skuImgSpuFilterLang === 'all') return allImages;
      return allImages.filter(img => img.language === this.skuImgSpuFilterLang);
    },
    /** 当前语言下的图套列表 */
    currentLangImageSets() {
      return this.skuImageSetList.filter(s => s.language === this.skuImgActiveTab);
    },
    /** 当前语言激活的图套 id */
    currentActiveSetId() {
      return this.skuActiveSetId[this.skuImgActiveTab] || null;
    },
    /** 当前语言激活的图套对象 */
    currentActiveSet() {
      if (!this.currentActiveSetId) return this.currentLangImageSets[0] || null;
      return this.currentLangImageSets.find(s => s.productGoodsImageSetId === this.currentActiveSetId) || this.currentLangImageSets[0] || null;
    },
    /** 当前激活图套的图片路径数组 */
    currentSetImages() {
      if (!this.currentActiveSet) return [];
      return this.currentActiveSet.images || [];
    },
    // 是否为服装分类类型
    isClothingType() {
      const selectCategoryType = this.getTypeInfo(this.treeSelectCategoryValue);
      if (this.$common.isEmpty(selectCategoryType)) return false;
      return selectCategoryType.productType == '0';
    },
    // 颜色所有值
    getColorAll() {
      if (this.$common.isEmpty(this.colorList)) return [];
      return this.colorList.map(m => m.color);
    },
    // 获取尺码末级的值
    getSizeVal() {
      if (this.$common.isEmpty(this.sizeList)) return [];
      const sizeVal = this.handSizeList(this.sizeList);
      return sizeVal;
    },
    // 是否存在多余的多属性
    isAttrTips() {
      const notItem = this.skuPropertyList.filter((item, index) => {
        if (index == 0 && this.sizeList.length != 0 && !this.isOldData) {
          return !this.$common.isEmpty(item.values.find(f => {
            return !this.getColorAll.includes(f);
          }));
        } else if (index == 1 && this.sizeList.length != 0 && !this.isOldData) {
          return !this.$common.isEmpty(item.values.find(f => {
            return !this.getSizeVal.includes(f);
          }));
        }
        return false;
      })
      return !this.$common.isEmpty(notItem);
    },
    // 尺码图
    dimensionPlan() {
      if (this.$common.isEmpty(this.productInfo)) return '';
      let sizeImageList = this.productInfo.productImageTypeList || [];
      if (this.$common.isEmpty(sizeImageList)) {
        sizeImageList = this.productInfo.productImageList || [];
      }
      if (this.$common.isEmpty(sizeImageList)) return '';
      const planImgObj = sizeImageList.find(f => {
        return [2, 3, 4, '2', '3', '4'].includes(f.imageType);
      })
      if (this.$common.isEmpty(planImgObj)) return;
      return `${this.filenodeViewTargetUrl}${planImgObj.path}`;
    },
    permission() {
      return {
        synchronous: this.getPermission('productInfo_synListing'), // 同步Listing权限
        update: this.getPermission('productInfo_update'), // 编辑商品详情权限
        gpsrTemplate: this.getPermission('gpsr_templateManage'), // gpsr 模板权限
        editGpsr: this.getPermission('gpsr_edit'), // 编辑 gpsr 资料权限
        deleteGpsr: this.getPermission('gpsr_delete'), // 删除 gpsr 资料权限
        deleteBritain: this.getPermission('gpsr_britainAgentInfoDelete'), // GPSR填写模板-删除英代信息
        deleteEurope: this.getPermission('gpsr_europeAgentInfoDelete'), // GPSR填写模板-删除欧代信息
        deleteIdent: this.getPermission('gpsr_identificationInfoDelete'), // GPSR填写模板-删除标识信息
        deleteManu: this.getPermission('gpsr_manufacturerInfoDelete'), // GPSR填写模板-删除生产商信息
        deleteWarning: this.getPermission('gpsr_securityWarningInfoDelete'), // GPSR填写模板-删除安全警告信息
        sales: this.isDisabled,
      }
    },
    // 是否禁用编辑
    isDisabled() {
      if (this.editStatus === 'add') return false;
      if (this.editStatus === 'eidt') return !this.permission.update;
      return this.editStatus === 'look';
    },
    // 是否是供应商商户
    isSupplierTalg() {
      return this.$store.state.erpConfig.merchant.isSupplier === 1;
    },
    textTalg() {
      return this.$store.state.erpConfig.merchant.isSupplier === 1
        ? '分销价格'
        : '采购成本价';
    }
  },
  methods: {
    handSizeList(data, oldVal = [], key) {
      let valList = [...oldVal];
      data.forEach(item => {
        if (!item.disabled) {
          if (item.children) {
            valList = [...valList, ...this.handSizeList(item.children, valList, 'key')];
          } else {
            valList.push(item.size);
          }
        }
      });
      return this.$common.arrRemoveRepeat(valList);
    },
    // 获取水洗唛数据
    getWashableList () {
      this.washableDataList = [];
      this.washableDataJson = {};
      return new Promise((resolve) => {
        this.axios.post(api.washableQueryList, {
          maintenanceInstructions: null
        }).then(res => {
          if (res && res.data && res.data.code == 0) {
            (res.data.datas || []).forEach(item => {
              this.$set(this.washableDataJson, item.id, item);
            });
            this.washableDataList = res.data.datas || [];
            resolve({ state: 'finally', data: res.data.datas || [] });
            return;
          }
          resolve({ state: 'finally', data: [] });
        }).catch(() => {
          resolve({ state: 'finally', data: [] });
        })
      })
    },
    // 获取对应商品是否有 GPSR 资料
    getGpsrInfo (productGoodsIds = []) {
      return new Promise((resolve) => {
        if (this.$common.isEmpty(productGoodsIds)) return resolve({ data: [] });
        this.axios.post(api.queryGpsrLabelInfo, productGoodsIds).then(res => {
          if (!res || !res.data || res.data.code != 0) return resolve({ data: [] });
          this.pageGpsrInfo = this.$common.isEmpty(res.data.datas) ? {} : res.data.datas[0];
          return resolve({ data: res.data.datas || [] });
        }).catch(() => {
          resolve({ data: [] });
        })
      })
    },
    // 需要移除的表格列
    removeTableColumn () {
      // 当详情为空或 isSnapwear 不为1时
      let removeKey = [];
      if (this.$common.isEmpty(this.productInfo) && ![1].includes(Number(this.productInfo.isSnapwear))) {
        removeKey = ['embryonicClothSku', 'embryonicClothDescription', 'printingImagePath'];
        this.skuColumns = this.skuColumns.filter(item => {
          return !removeKey.includes(item.key);
        });
      }
    },
    // 延迟显示对应的必要 tab 标签页面
    delayTabShow (type = false) {
      let hIndex = 0;
      const hand = (key) => {
        if (this.$common.isUndefined(this.pageTagView[key])) {
          this.$set(this.pageTagView, key, true);
        } else if (!this.pageTagView[key]) {
          this.pageTagView[key] = true;
        }
        this.$nextTick(() => {
          setTimeout(() => {
            hIndex++;
            if (!this.$common.isEmpty(showTabKey[hIndex])) {
              hand(showTabKey[hIndex]);
            } else if (!type) {
              this.spinShow = false;
            }
          }, 300)
        })
      };
      if (!this.$common.isEmpty(showTabKey[hIndex])) {
        hand(showTabKey[hIndex]);
      }
    },
    // 往前追溯分类类型，直到找到为止或全部
    getTypeInfo(id) {
      if (this.$common.isEmpty(this.treeSelectCategoryJson) || this.$common.isEmpty(id)) return null;
      const getInfo = this.treeSelectCategoryJson[id];
      if (this.$common.isEmpty(getInfo)) return null;
      if (this.$common.isEmpty(getInfo.productType)) {
        if (this.$common.isEmpty(getInfo.parentId)) return null;
        return this.getTypeInfo(getInfo.parentId);
      }
      return getInfo;
    },
    // 过滤多属性列表（新增的属性信息将不匹配尺码组和颜色属性的数据过滤掉）
    // filterSkuData (defualtList) {
    //   const newTableData = defualtList.filter(row => {
    //     if (this.$common.isEmpty(row.productGoodsId) && !this.$common.isEmpty(row.productGoodsSpecifications)) {
    //       const notMatch = row.productGoodsSpecifications.find(item => {
    //         if (item.name == 'Color') {
    //           return !this.getColorAll.includes(item.value)
    //         } else if (item.name == 'Size') {
    //           return !this.getSizeVal.includes(item.value)
    //         }
    //       })
    //       return this.$common.isEmpty(notMatch);
    //     }
    //     return true;
    //   })
    //   return newTableData
    // },
    // 数据格式
    textInit(data = [], productId) {
      const additional = ['productId', 'title', 'keywords', 'language', 'descriptionId'];
      this.languageTab.forEach(item => {
        this.$set(this.descriptionBOJson, item.key, {});
        const langCont = data.filter(cont => {
          return item.key == cont.language;
        })
        additional.forEach(key => {
          if (langCont[0]) {
            let val = langCont[0][key];
            if (key == 'keywords') {
              val = langCont[0][key] || [];
              if (!Array.isArray(langCont[0][key]) && !this.$common.isEmpty(langCont[0][key])) {
                val = (langCont[0][key].split(',')).filter(isVal => {
                  return !!isVal
                }).map(newVal => {
                  return { attrVal: newVal }
                })
              }
            } else if (key == 'productId') {
              val = langCont[0][key] ? langCont[0][key] : productId || '';
            }
            this.$set(this.descriptionBOJson[item.key], key, val);
          } else {
            this.$set(this.descriptionBOJson[item.key], key, key == 'keywords' ? [] : '');
          }
        })
        this.descriptionTab.forEach(text => {
          if (langCont[0]) {
            this.$set(this.descriptionBOJson[item.key], text.key, langCont[0][text.key] || '');
          } else {
            this.$set(this.descriptionBOJson[item.key], text.key, '');
          }
        })
      })
    },
    // 语言切换时更新数据多文本数据
    langTabsSwitch() {
      if (this.descActiveTab == 'textDescription') return;
      this.descriptionBOJson[this.oldActiveLang][this.oldActiveDesc] = this.editor.getContent();
      this.$nextTick(() => {
        const content = this.descriptionBOJson[this.langActiveTab][this.descActiveTab];
        this.editor.setContent(content);
        this.oldActiveLang = this.langActiveTab;
      })
    },
    // 描述类型切换时更新数据多文本数据
    descTabsSwitch() {
      if (this.descActiveTab == 'textDescription') return;
      this.descriptionBOJson[this.oldActiveLang][this.oldActiveDesc] = this.editor.getContent();
      this.$nextTick(() => {
        const content = this.descriptionBOJson[this.langActiveTab][this.descActiveTab];
        this.editor.setContent(content);
        this.oldActiveDesc = this.descActiveTab;
      })
    },
    // 数据转换
    textTranform(productInfo) {
      return new Promise((resolve) => {
        this.descriptionBOJson[this.oldActiveLang][this.oldActiveDesc] = this.editor.getContent();
        this.$nextTick(() => {
          let newData = Object.values(JSON.parse(JSON.stringify(this.descriptionBOJson)));
          const keys = Object.keys(this.descriptionBOJson);
          newData.forEach((item, index) => {
            !item.productId && (item.productId = productInfo.productId || '');
            !item.language && (item.language = keys[index]);
            item.keywords = item.keywords.map(val => {
              return val.attrVal;
            }).join(',');
          })
          resolve(newData);
        })
      })
    },
    // skc 验证
    validateFormSkc(value) {
      let reg = /^[0-9]*$/g;
      if (!reg.test(value)) {
        return false;
      }
      return true;
    },
    getCommodityDeveloper () {
      return new Promise((resolve) => {
        // commodityDeveloper（即商品开发员）
        this.axios.get(api.get_queryByBusinessRoleType + 'commodityDeveloper').then((res) => {
          if (res && res.data && res.data.code === 0) {
            // this.businessRoleTypeList = res.data.datas;
            this.businessRoleTypeList = res.data.datas.filter(k => {
              return k.status === '1'
            })
          }
        }).finally(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    addSkuPic(path, language) { // 添加至SKU（按语言加入对应分组）
      const lang = language || this.skuImgActiveTab;
      if (!this.productGoodsImageArray[lang]) {
        this.$set(this.productGoodsImageArray, lang, []);
      }
      this.productGoodsImageArray[lang].push(path);
    },
    removeProductGoodsImg(imgPath) { // 删除当前语言分组下的图片
      const arr = this.productGoodsImageArray[this.skuImgActiveTab];
      if (!arr) return;
      const idx = arr.indexOf(imgPath);
      if (idx !== -1) arr.splice(idx, 1);
    },
    setProductGoodsPrimaryImg(imgPath) { // 设置当前语言分组主图（置顶）
      const arr = this.productGoodsImageArray[this.skuImgActiveTab];
      if (!arr) return;
      const idx = arr.indexOf(imgPath);
      if (idx !== -1) arr.splice(idx, 1);
      arr.unshift(imgPath);
    },
    confirModifyProductGoodsImg() { // 确认修改图片
      const productGoodsId = this.productInfo.productGoodsList[this.editIndex].productGoodsId;
      // 构建 applySpecificationNames：勾选 model 传 "Model"，勾选 color 传 "Color"
      const activeLang = this.skuImgActiveTab;
      const applySpecificationNames = [];
      if (this.isSynchroAllSkcModel[activeLang]) applySpecificationNames.push('Model');
      if (this.isSynchroAllSkcColor[activeLang]) applySpecificationNames.push('Color');

      // 遍历当前 SKU 的所有图套，逐个调用 saveImages 接口
      const saveRequests = this.skuImageSetList.map(imgSet => {
        const payload = {
          productGoodsId,
          imageSetId: imgSet.productGoodsImageSetId,
          language: imgSet.language,
          images: (imgSet.images || []).map(img => {
            return {
              path: img
            }
          }),
          applySpecificationNames
        };
        return payload;
        // return this.axios.post(api.saveImages_productGoodsImageSet, payload);
      });
      // Promise.all(saveRequests)
      this.axios.post(api.saveImagesBatch_productGoodsImageSet, saveRequests).then(res => {
        // const allSuccess = results.every(res => res && res.data && res.data.code === 0);
        if (res.data.code !== 0) {
          this.$Message.warning('图套保存未成功，请刷新后确认');
          return;
        }
        this.$Message.success('图套保存成功');
        // 接口全部成功后再更新本地数据，使商品多属性列表图片列同步刷新
        const newImages = [];
        this.skuImageSetList.forEach(imgSet => {
          (imgSet.images || []).forEach(path => {
            newImages.push({ path, language: imgSet.language });
          });
        });
        const list = this.productInfo.productGoodsList;
        const currentItem = list[this.editIndex];
        const model = (currentItem.productGoodsSpecifications && currentItem.productGoodsSpecifications[1])
          ? currentItem.productGoodsSpecifications[1].value || ''
          : '';
        const color = (currentItem.productGoodsSpecifications && currentItem.productGoodsSpecifications[0])
          ? currentItem.productGoodsSpecifications[0].value || ''
          : '';
        list.forEach((k, i) => {
          const kModel = (k.productGoodsSpecifications && k.productGoodsSpecifications[1])
            ? k.productGoodsSpecifications[1].value || ''
            : '';
          const kColor = (k.productGoodsSpecifications && k.productGoodsSpecifications[0])
            ? k.productGoodsSpecifications[0].value || ''
            : '';
          const matchModel = this.isSynchroAllSkcModel[activeLang] && model && kModel === model;
          const matchColor = this.isSynchroAllSkcColor[activeLang] && color && kColor === color;
          if (i === this.editIndex || matchModel || matchColor) {
            k.productGoodsImages = this.deepCopy(newImages);
          }
        });
        // 同步更新 skuData，使子组件 productMultiattribute 能感知变化
        this.skuData = this.deepCopy(list);

        // 同步更新 multiLangImageData（productImageInfo 组件数据源）
        // 按语言分组 newImages，合并到 multiLangImageData，相同 path 跳过
        const newImagesByLang = {};
        newImages.forEach(({ path, language }) => {
          if (!newImagesByLang[language]) newImagesByLang[language] = [];
          newImagesByLang[language].push(path);
        });
        const updatedMultiLang = this.deepCopy(this.multiLangImageData);
        Object.keys(newImagesByLang).forEach(language => {
          const paths = newImagesByLang[language];
          const groupIdx = updatedMultiLang.findIndex(g => g.language === language);
          if (groupIdx === -1) {
            // 该语言分组不存在，新建
            updatedMultiLang.push({
              language,
              images: paths.map(path => ({ path, imageType: null }))
            });
          } else {
            // 该语言分组已存在，追加不重复的图片
            const existingPaths = new Set((updatedMultiLang[groupIdx].images || []).map(img => img.path));
            paths.forEach(path => {
              if (!existingPaths.has(path)) {
                updatedMultiLang[groupIdx].images.push({ path, imageType: null });
              }
            });
          }
        });
        this.multiLangImageData = updatedMultiLang;

        this.modifyProductGoodsImgModal = false;
      })
    },
    uploadModalCancel() { // 上传图片模态框取消
      this.productGoodsImageArray = {};
      this.skuImageSetList = [];
      this.skuActiveSetId = {};
      this.modifyProductGoodsImgModal = false;
    },
    // 处理树节点
    treeNormalizer(node) {
      return {
        id: node.productCategoryId,
        label: node.title,
        children: node.children
      }
    },
    // 所属分类改变
    getTreeData(treeId) { // 选择分类时把id赋值给商品模型分类ID
      let productCategory = this.treeSelectCategoryJson[treeId] || {};
      if (['productCategoryId1'].includes(treeId)) {
        this.$nextTick(() => {
          this.$Message.error('“全部” 选项不可选中');
          this.treeSelectCategoryValue = this.productInfo.productCategoryId
        })
        return
      }
      if (['productCategoryId1', 'noCategory'].includes(treeId)) {
        delete productCategory.productCategoryId
      }
      const hand = {
        findExistValue: () => {
          if (!productCategory || this.productInfo.productCategoryId != productCategory.productCategoryId) {
            // 当 productId 为空是，切换属性不提示 !this.categoryChange
            if (!this.attributeFom.productId || !productCategory.productCategoryId) {
              hand.changeData();
              return;
            }
            this.axios.post(api.categoryAttributeAgreement, {
              productIdList: [this.attributeFom.productId],
              newCategoryId: productCategory.productCategoryId,
              selectAll: 0,
            }).then(res => {
              if (res.data.code == 0) {
                if (!this.$common.isEmpty(res.data.datas)) {
                  this.$Modal.confirm({
                    title: '提示',
                    width: 600,
                    content: `<p>修改分类前后绑定属性不同，需要重新录入商品属性资料，是否确认修改所属分类？</p>`,
                    onOk: () => {
                      hand.changeData();
                    },
                    onCancel: () => {
                      this.initCategoryTree(this.productInfo.productCategoryId);
                      this.initGetTreeData = true
                    }
                  });
                } else {
                  hand.changeData(false);
                }
              } else {
                hand.changeData();
              }
            })
          }
        },
        changeData: (attrChange = true) => {
          if (productCategory && productCategory.productCategoryId) {
            const oldId = this.productInfo.productCategoryId;
            this.productInfo.productCategoryId = productCategory.productCategoryId;
            this.$set(this.attributeFom, 'productCategoryId', productCategory.productCategoryId);
            this.productInfo.cnHsName = productCategory.cnHsName;
            this.productInfo.enHsName = productCategory.enHsName;
            this.productInfo.hsCode = productCategory.hsCode;
            if (attrChange || this.oldAttrChange || this.$common.isEmpty(oldId)) {
              this.$nextTick(() => {
                this.getAttributeData({
                  productCategoryId: productCategory.productCategoryId,
                  productId: productCategory.productId || ''
                }, false);
                this.$nextTick(() => {
                  this.$refs['attributeDome'] && this.$refs['attributeDome'].resetFields();
                });
              });
            }
          } else {
            this.productInfo.productCategoryId = null;
            this.productInfo.cnHsName = null;
            this.productInfo.enHsName = null;
            this.productInfo.hsCode = null;
            this.$set(this.attributeFom, 'attributeValueQOList', []);
            this.$nextTick(() => {
              this.$refs['attributeDome'] && this.$refs['attributeDome'].resetFields();
            });
          }
          this.oldAttrChange = attrChange;
          this.getSizeList();
        }
      };
      if (!this.initGetTreeData) {
        this.initGetTreeData = false
        hand.findExistValue();
      }
    },
    getYmsTreeData(productCategory) {
      if (productCategory && productCategory.ymsProductCategoryId) {
        this.productInfo.ymsProductCategoryId = productCategory.ymsProductCategoryId;
        this.classifyTalg = 'change';
        this.getTemplateData(productCategory.ymsProductCategoryId);
      } else {
        this.productInfo.ymsProductCategoryId = null;
      }
    },
    validateCustomFields(newProduct) { // 校验货品属性
      let error = false;
      this.validateCol = {
        isWeight: [],
        isLength: [],
        isWidth: [],
        isHeight: [],
        isSuggestPrice: []
      }
      const reg = /^([1-9]\d*(\.\d{1,2})?|([0](\.([0][1-9]|[1-9]\d{0,1}))))$/;
      if (!newProduct.productGoodsList) return !error;
      for (let i = 0; i < newProduct.productGoodsList.length; i++) {
        let productGoods = newProduct.productGoodsList[i];
        !reg.test(productGoods.weight) && this.validateCol.isWeight.push(i);
        !reg.test(productGoods.length) && this.validateCol.isLength.push(i)
        !reg.test(productGoods.width) && this.validateCol.isWidth.push(i);
        !reg.test(productGoods.height) && this.validateCol.isHeight.push(i)
        // !reg.test(productGoods.suggestPrice) && this.validateCol.isSuggestPrice.push(i);
        if (productGoods.productGoodsSpecifications) {
          productGoods.productGoodsSpecifications.forEach((productGoodsSpecification, index) => {
            if (productGoodsSpecification.value === null || productGoodsSpecification.value === '') {
              error = true;
            }
          });
          if (error) {
            this.activeTab = 'baseInfo';
            break;
          }
        }
      }
      return !error;
    },
    // 保存前校验
    beforeSave(value) {
      // let status = null; // 1 质检项为空  2 质检项中的内容为空  3 质检类目为空
      // let itemFlg = null; // 1 质检项为空  2 质检标准为空
      this.productInfo.operationType = value ? 1 : 0;

      // 处理及校验质检标准数据
      /* if (this.categoryList && this.categoryList.length) {
        this.categoryList.forEach((s, v) => {
          if (!s.measureVal.length) {
            status = 1;
          } else {
            s.measureVal.forEach((j, k) => {
              if (!j.itemName) {
                status = 2;
                itemFlg = 1;
              } else if (!j.itemValue) {
                status = 2;
                itemFlg = 2;
              }
            });
          }
          if (!s.measureName) {
            status = 3;
          }
        });
        if (status === 1) {
          this.$Message.error('有无质检项的类目，请删除改类目或添加质检项后保存');
          this.waitingOk = false;
          return false;
        } else if (status === 2) {
          if (itemFlg === 1) {
            this.$Message.error('质检项不能为空');
            this.waitingOk = false;
            return false;
          } else if (itemFlg === 2) {
            this.$Message.error('质检标准不能为空');
            this.waitingOk = false;
            return false;
          }
        }
        if (status === 3) {
          this.$Message.error('质检类目不能为空');
          this.waitingOk = false;
          return false;
        }
        // 若无异常，则组装质检数据
        let pos = [];
        this.categoryList.forEach((n, i) => {
          n.measureVal.forEach((m, t) => {
            pos.push({
              itemName: m.itemName,
              itemValue: m.itemValue,
              measureName: n.measureName
            });
          });
        });
        this.productInfo.productQualityMeasureList = pos;
      } */

      const hand = {
        productInfoValid: (newProduct) => {
          this.showSpin('处理中...');
          this.waitingOk = true;
          this.$refs['productInfo'].validate((valid) => {
            let isPass = false;
            isPass = this.validateCustomFields(newProduct);

            if (valid && isPass) {
              const keys = Object.keys(this.validateCol);
              const nowKey = keys.find(key => {
                return this.validateCol[key].length > 0;
              })
              if (this.$common.isEmpty(nowKey)) {
                hand.attributeValidate();
                return;
              }
              const getDemo = document.querySelector(`.${nowKey}-${this.validateCol[nowKey][0]}`);
              if (getDemo) {
                this.locationErrorInput('multiattribute', '多属性资料列表中的价格，重量，尺寸需大于 0 并且最多2位小数的数字');
                this.$nextTick(() => {
                  getDemo.querySelector('input').focus();
                })
              }
              this.waitingOk = false;
              this.hideSpin();
            } else {
              this.locationErrorInput('baseInfo', '基础资料中存在必填项未填写或格式有误，请确保正确填写');
              this.waitingOk = false;
              this.hideSpin();
            }
          });
        },
        attributeValidate: () => {
          this.$refs.attributeDome ? this.$refs.attributeDome.validate((attrvalid) => {
            if (!attrvalid) {
              this.waitingOk = false;
              this.hideSpin();
              this.locationErrorInput('baseInfo', '商品属性信息存在必填项未填写');
              document.querySelectorAll('.editProductDome .ivu-sliderModal-body')[0].scrollTop = 0;
              return;
            }
            hand.productInfo();
          }) : hand.productInfo();
        },
        productInfo: () => {
          new Promise((resolve, reject) => {
            this.saveInfo(resolve);
          }).then(() => {
            this.waitingOk = false;
            this.hideSpin();
          }).catch(() => {
            this.waitingOk = false;
            this.hideSpin();
          });
        }
      };
      const qualityDemo = this.$refs.qualityInspection;
      let qualityVal = '';
      if (qualityDemo) {
        const getFormData = qualityDemo.getFormData();
        if (!getFormData.newType) {
          qualityVal = getFormData.data;
          // this.productInfo.qualityTemplateId = qualityVal;
          this.productInfo.qualityClassificationId = qualityVal || null;
          this.$nextTick(() => {
            hand.productInfoValid(this.productInfo);
          })
        } else {
          qualityDemo.validate((valid) => {
            if (!valid) return;
            this.showSpin('处理中...');
            this.waitingOk = true;
            this.newSaveQuality(getFormData.data).then((sRes) => {
              this.hideSpin();
              this.waitingOk = false;
              if (!sRes.state) return;
              // this.productInfo.qualityTemplateId = qualityVal;
              this.productInfo.qualityClassificationId = qualityVal || null;
              // this.productInfo.tempQualityClassificationId = null;
              this.$nextTick(() => {
                hand.productInfoValid(this.productInfo);
              })
            });
          })
        }
      } else {
        // this.productInfo.qualityTemplateId = qualityVal;
        this.productInfo.qualityClassificationId = qualityVal || null;
        this.$nextTick(() => {
          hand.productInfoValid(this.productInfo);
        })
      }
    },
    // 质检标准新逻辑保存
    newSaveQuality (formParams) {
      return new Promise((resolve) => {
        this.axios.post(api.batchUpdateQualityTemplate, formParams).then(res => {
          if (res.data && res.data.code == 0) {
            return resolve({ state: true });
          }
          resolve({ state: false });
        }).catch(() => {
          resolve({ state: false });
        })
      })
    },
    // 定位到验证不通过的地方
    locationErrorInput(errorTag, errTxt, type = false) {
      this.pageEditTag = errorTag;
      if (type) return;
      if (!this.$common.isEmpty(errTxt)) {
        this.$Message.error(errTxt);
      }
      setTimeout(() => {
        this.$nextTick(() => {
          this.hideSpin();
          this.waitingOk = false;
          // 定位到第一个验证不通过项位置
          this.$nextTick(() => {
            let errorDemo = document.querySelector(`.tag-content-${errorTag} .ivu-form-item-error`);
            if (!this.$common.isEmpty(errorDemo)) {
              const textDemo = errorDemo.querySelector('input[type="text"]');
              errorDemo = this.$common.isEmpty(textDemo) ? errorDemo.querySelector('textarea') : textDemo;
              if (!this.$common.isEmpty(errorDemo)) {
                errorDemo.focus();
              }
            }
          })
        })
      }, 500)
    },
    // 保存
    async saveInfo (resolve) {
      // 深拷贝，防止修改到表单值
      let newProductInfo = this.$common.copy(this.productInfo);
      // 处理多语言图片数据
      newProductInfo.multiLangImages = this.multiLangImageData.map(m => {
        return {
          language: m.language,
          productImages: this.$common.isEmpty(m.images) ? [] : m.images.map(i => i.path)
        };
      });
      // productGoodsImages 只需要 common 的数据
      if (!this.$common.isEmpty(newProductInfo.productGoodsList)) {
        newProductInfo.productGoodsList.forEach(item => {
          item.productGoodsImages = (item.productGoodsImages || []).filter(f => {
            return f.language == 'common';
          }).map(m => m.path);
        })
      }
      delete newProductInfo.multiLangImageList; // 删除多语言图片列表(保存时候不需要)
      delete newProductInfo.productImageList; // 删除图片列表(保存时候不需要)
      delete newProductInfo.productImages; // 删除图片列表(保存时候不需要)
      newProductInfo.newSupplierCheck = newProductInfo.newSupplierCheck ? 1 : 0;
      newProductInfo.basicSpecificationVerification = newProductInfo.basicSpecificationVerification ? 1 : 0;
      if (newProductInfo.productGoodsList.length === 1 &&
        (!newProductInfo.productGoodsList[0].productGoodsSpecifications || newProductInfo.productGoodsList[0].productGoodsSpecifications.length == 0)
      ) {
        newProductInfo.productGoodsList[0].sku = newProductInfo.spu;
        newProductInfo.productGoodsList[0].productGoodsAcceptableTc = this.productTypeListValue.join(',');
        delete newProductInfo.productGoodsList[0].productTypeListValue;
      }
      // 当不是服装分类类型时，braidType 要设置为空
      if (!this.isClothingType) {
        newProductInfo.braidType = null;
      }
      if (!this.$common.isEmpty(newProductInfo.washedLabelWordFile)) {
        newProductInfo.washedLabelWordPath = newProductInfo.washedLabelWordFile.fileUrl;
        newProductInfo.washedLabelWordName = newProductInfo.washedLabelWordFile.fileName;
        delete newProductInfo.washedLabelWordFile;
      } else {
        newProductInfo.washedLabelWordPath = '';
        newProductInfo.washedLabelWordName = '';
      }
      // 组装信息
      if (newProductInfo.productGoodsList) {
        newProductInfo.productGoodsList.forEach((n, i) => {
          if (n.upc === '') {
            n.upc = null;
          }
          if (n.isAssemble) { // 先判断是否是组装产品
            if (n.editStatus) { // 判断是否重新编辑
              n.isAssemble = 1;
              if (n.productGoodsAssembles) {
                let pos = [];
                for (let m = 0; m < n.productGoodsAssembles.length; m++) {
                  pos.push({
                    materialProductGoodsId: n.productGoodsAssembles[m].productGoodsId,
                    quantity: n.productGoodsAssembles[m].quantity
                  });
                }
                n.productGoodsAssembles = pos;
              } else {
                n.isAssemble = 0;
                n.productGoodsAssembles = [];
              }
            } else {
              n.isAssemble = 1;
              if (n.productGoodsAssembles) {
                let box = [];
                for (let t = 0; t < n.productGoodsAssembles.length; t++) {
                  box.push({
                    materialProductGoodsId: n.productGoodsAssembles[t].materialProductGoodsId
                      ? n.productGoodsAssembles[t].materialProductGoodsId
                      : n.productGoodsAssembles[t].productGoodsId,
                    quantity: n.productGoodsAssembles[t].quantity
                  });
                }
                n.productGoodsAssembles = box;
              } else {
                n.isAssemble = 0;
                n.productGoodsAssembles = [];
              }
            }
          } else {
            n.isAssemble = 0;
            n.productGoodsAssembles = [];
          }
          n.productGoodsAcceptableTc = n.productTypeListValue && n.productTypeListValue.length ? n.productTypeListValue.join(',') : null;
          delete n.productTypeListValue;
        });
      }
      newProductInfo.descriptionBOList = await this.textTranform(newProductInfo);
      // 是供应商用户才做校验
      if (this.isSupplierTalg) {
        if (newProductInfo.ymsProductCategoryId === null) {
          this.locationErrorInput('baseInfo', '请选择云卖分类！');
          this.waitingOk = false;
          this.hideSpin();
          return false;
        }
        // 处理尺码表的参数
        if (this.classifyTalg === 'edit') {
          if (this.sizeChartdata.length > 0 && Object.keys(this.sizeJsonData).length > 0) {
            let insetProductSizeBoList = [];
            let data = this.sizeJsonData.productSizePartsBos;
            this.sizeChartdata.forEach((item) => {
              let obj = {
                sizeCode: '',
                ukSize: '',
                euSize: '',
                usSize: '',
                sizeDetailBos: []
              };
              data.forEach((ele, index) => {
                obj.sizeDetailBos.push({
                  partsName: item['partsName_' + index],
                  unitName: item['unitName_' + index],
                  unitValue: item['unitValue_' + index]
                });
              });
              obj.sizeCode = item.sizeCode;
              obj.ukSize = item.ukSize;
              obj.euSize = item.euSize;
              obj.usSize = item.usSize;
              insetProductSizeBoList.push(obj);
            });
            newProductInfo.insetProductSizeBoList = insetProductSizeBoList;
            newProductInfo.sizeJson = JSON.stringify(this.sizeJsonData);
            if (newProductInfo.insetProductSizeBoList.length > 0) {
              let list = newProductInfo.insetProductSizeBoList;

              let valid = false;
              let obj = {};

              for (let i = 0; i < list.length; i++) {
                for (let key in list[i]) {
                  if (key !== 'sizeDetailBos') {
                    if (!obj[key]) {
                      obj[key] = [list[i][key]];
                    }
                    obj[key].push(list[i][key]);
                  }
                }
                for (let j = 0; j < list[i].sizeDetailBos.length; j++) {
                  let t = list[i].sizeDetailBos[j];
                  if (!obj[t.partsName]) {
                    obj[t.partsName] = [];
                  }
                  obj[t.partsName].push(t.unitValue);
                }
              }
              for (let key in obj) {
                if (obj[key].some(k => k && k !== '0') && obj[key].some(k => !k || Number(k) === 0)) {
                  valid = true;
                }
              }
              if (valid) {
                this.$Message.error('尺码表单独规格必须填写完整！');
                this.waitingOk = false;
                this.hideSpin();
                return false;
              }
            }
          } else {
            delete newProductInfo.insetProductSizeBoList;
          }
        } else if (this.classifyTalg === 'change') {
          if (this.sizeChartdata.length > 0 && Object.keys(this.sizeJsonData).length > 0) {
            let insetProductSizeBoList = [];
            let data = this.sizeJsonData.productSizePartsBos;
            this.sizeChartdata.forEach(item => {
              let obj = {
                sizeCode: '',
                ukSize: '',
                euSize: '',
                usSize: '',
                sizeDetailBos: []
              };
              data.forEach(ele => {
                obj.sizeDetailBos.push({
                  partsName: item[ele.ymsProductSizePartsId + '_partName'],
                  unitName: item[ele.ymsProductSizePartsId + '_defaultUnitName'],
                  unitValue: item[ele.ymsProductSizePartsId + '_defaultValue']
                });
              });
              obj.sizeCode = item.size;
              obj.ukSize = item.ukSize;
              obj.euSize = item.euSize;
              obj.usSize = item.usSize;
              insetProductSizeBoList.push(obj);
            });
            newProductInfo.insetProductSizeBoList = insetProductSizeBoList;
            newProductInfo.sizeJson = JSON.stringify(this.sizeJsonData);
            if (newProductInfo.insetProductSizeBoList.length > 0) {
              let list = newProductInfo.insetProductSizeBoList;
              let valid = false;
              let obj = {};
              for (let i = 0; i < list.length; i++) {
                for (let key in list[i]) {
                  if (key !== 'sizeDetailBos') {
                    if (!obj[key]) {
                      obj[key] = [list[i][key]];
                    }
                    obj[key].push(list[i][key]);
                  }
                }
                for (let j = 0; j < list[i].sizeDetailBos.length; j++) {
                  let t = list[i].sizeDetailBos[j];
                  if (!obj[t.partsName]) {
                    obj[t.partsName] = [];
                  }
                  obj[t.partsName].push(t.unitValue);
                }
              }
              for (let key in obj) {
                if (obj[key].some(k => k && k !== '0') && obj[key].some(k => !k || Number(k) === 0)) {
                  valid = true;
                }
              }
              if (valid) {
                this.$Message.error('尺码表单独规格必须填写完整!');
                this.waitingOk = false;
                this.hideSpin();
                return false;
              }
            }
          } else {
            delete newProductInfo.insetProductSizeBoList;
          }
        }
      }
      if (newProductInfo.type == 2) {
        newProductInfo.productGoodsList.forEach(k => {
          (k.productGoodsSpecifications || []).forEach(j => {
            if (this.$common.isEmpty(j.value)) {
              this.$set(j, 'value', '');
            }
            if (j.name == 'Color' && !this.isOldData) {
              if (this.getColorAll.includes(j.value)) {
                this.colorList.forEach(m => {
                  if (j.value == m.color) {
                    this.$set(j, 'skcCode', m.skcCode);
                    this.$set(j, 'typeValueId', m.colorId);
                  }
                })
              } else if (this.specificationsObj[`${j.name}${j.value}`]) {
                this.$set(j, 'typeValueId', this.specificationsObj[`${j.name}${j.value}`].typeValueId);
              }
              j.type = 1;
            } else if (j.name == 'Size' && !this.isOldData) {
              if (this.getSizeVal.includes(j.value)) {
                this.sizeList.forEach(m => {
                  if (!m.disabled) {
                    m.children.forEach(n => {
                      if (j.value == n.size) {
                        this.$set(j, 'sizeCode', n.sizeCode);
                        this.$set(j, 'typeValueId', n.sizeId);
                      }
                    })
                  }
                })
              } else if (this.specificationsObj[`${j.name}${j.value}`]) {
                this.$set(j, 'typeValueId', this.specificationsObj[`${j.name}${j.value}`].typeValueId);
              }
              j.type = 2;
            } else {
              j.type = 3;
            }
          })
        })
      }

      let awaitRes = [];
      // 获取物料表单信息
      if (this.$refs.materialRefDemo) {
        awaitRes.push(() => {
          return new Promise((resolve, reject) => {
            this.$refs.materialRefDemo.getFormData(1).then(res => {
              if (!res.success) return reject(res);
              newProductInfo.productGoodsMaterialInfoVOList = res.data;
              newProductInfo.updateProductMaterialInfo = 1;
              resolve(res);
            }).catch((err) => {
              console.error(err);
              reject(err);
            })
          })
        })
      }
      // 获取其他费用
      if (this.$refs.refLaPaFeeType) {
        awaitRes.push(() => {
          return new Promise((resolve, reject) => {
            this.$refs.refLaPaFeeType.getFormData(1).then(res => {
              if (!res.success) return reject(res);
              newProductInfo.productFeeTypeList = res.data;
              resolve(res);
            }).catch((err) => {
              console.error(err);
              reject(err);
            })
          })
        })
      }
      // 获取其他费用
      if (this.$refs.processRequireInstructionsRef) {
        awaitRes.push(() => {
          return new Promise((resolve, reject) => {
            this.$refs.processRequireInstructionsRef.getFormData(1).then(res => {
              if (!res.success) return reject(res);
              newProductInfo.productProcessRequireList = res.data;
              resolve(res);
            }).catch((err) => {
              console.error(err);
              reject(err);
            })
          })
        })
      }

      // 获取工序表单信息(车缝工价)
      // if (this.$refs.sewingLaborRrateDemo) {
      //   awaitRes.push(() => {
      //     return new Promise((resolve, reject) => {
      //       this.$refs.sewingLaborRrateDemo.getFormData(1).then(res => {
      //         if (!res.success) return reject(res);
      //         newProductInfo.productProcessVOList = res.data.list;
      //         newProductInfo.machiningRate = res.data.machiningRate;
      //         newProductInfo.updateProductTechnology = 1;
      //         resolve(res);
      //       }).catch((err) => {
      //         console.error(err);
      //         reject(err);
      //       })
      //     })
      //   })
      // }
      // 获取工艺表单信息(工艺要求)
      // if (this.$refs.technologicalDemo) {
      //   awaitRes.push(() => {
      //     return new Promise((resolve, reject) => {
      //       this.$refs.technologicalDemo.getFormData(1).then(res => {
      //         if (!res.success) return reject(res);
      //         // newProductInfo.fileUrlList = res.data.fileUrlList;
      //         newProductInfo.laPaApiProductTechnologyVOList = res.data.list;
      //         newProductInfo.updateProductProcess = 1;
      //         resolve(res);
      //       }).catch((err) => {
      //         console.error(err);
      //         reject(err);
      //       })
      //     })
      //   })
      // }
      // 获取二次工艺表单信息(二次工艺要求)
      // if (this.$refs.twiceCraftDemo) {
      //   awaitRes.push(() => {
      //     return new Promise((resolve, reject) => {
      //       this.$refs.twiceCraftDemo.getFormData(1).then(res => {
      //         if (!res.success) return reject(res);
      //         newProductInfo.updateSecondaryProcess = 1;
      //         newProductInfo.productSecondaryProcessBOS = res.data;
      //         resolve(res);
      //       }).catch((err) => {
      //         console.error(err);
      //         reject(err);
      //       })
      //     })
      //   })
      // }
      // 生产尺码图
      // if (this.$refs.frameHoppingDemo) {
      //   awaitRes.push(() => {
      //     return new Promise((resolve, reject) => {
      //       this.$refs.frameHoppingDemo.getFormData(1).then(res => {
      //         if (!res.success) return reject(res);
      //         newProductInfo.productManufactureVOList = res.data;
      //         newProductInfo.updateProductManufacture = 1;
      //         resolve(res);
      //       }).catch((err) => {
      //         console.error(err);
      //         reject(err);
      //       })
      //     })
      //   })
      // }

      this.$common.promiseAll(awaitRes).then(() => {
        if (newProductInfo.productId) {
          resolve(this.axios.put(api.productInfo_update, newProductInfo).then(response => {
            if (response.data.code === 0) {
              this.insertAttributeSpu('edit', newProductInfo);
              this.$Message.success('更新成功');
            }
          }));
        } else {
          let attributeFom = this.insertAttributeSpu('add');
          delete attributeFom.productId;
          delete attributeFom.productCategoryId;
          resolve(this.axios.post(api.productInfo_insert, { ...newProductInfo, ...attributeFom }).then(response => {
            if (response.data.code === 0) {
              this.$Message.success('新增成功');
              this.synchronousRemind({ ...newProductInfo, ...attributeFom, productId: response.data.datas.productId || '' }, 'add');
            }
          }));
        }
      }).catch(err => {
        this.locationErrorInput('productionInfo');
        console.error(err);
        this.hideSpin();
        this.waitingOk = false;
      })
    },
    // 保存属性信息
    insertAttributeSpu(type, productInfo) {
      let attributeFom = JSON.parse(JSON.stringify(this.attributeFom));
      const attributeValueQOList = attributeFom.attributeValueQOList.map(item => {
        return {
          attributeValueIdList: typeof item.attributeValueIdList === 'number' ? [item.attributeValueIdList] : item.attributeValueIdList
        };
      });
      attributeFom.attributeValueQOList = attributeValueQOList.filter(item => {
        return typeof item.attributeValueIdList === 'number' || (item.attributeValueIdList && item.attributeValueIdList.length > 0);
      });
      if (type == 'add') {
        return attributeFom;
      }
      if (attributeFom.attributeValueQOList.length == 0) {
        this.synchronousRemind(productInfo);
        return;
      }
      this.axios.post(api.insert_attributeSpu, attributeFom).then(res => {
        if (res.data.code !== 0) {
          this.$Message.error('属性信息保存失败');
          this.synchronousRemind(productInfo);
        } else {
          this.synchronousRemind({ ...productInfo, ...attributeFom });
        }
      }).catch(() => {
        this.synchronousRemind(productInfo);
        this.$Message.error('属性信息保存失败');
      });
    },
    /* del () { // 删除
      let self = this;
      self.productInfo.productGoodsList = [];
      self.axios.put(api.productInfo_update, self.productInfo).then(response => {
        if (response.data.code === 0) {
          self.$Message.success('删除成功');
          self.$parent.$parent.pageParamsStatus = true;
          // self.$parent.$parent.editProductModal = false;
          this.$emit('update:editProductModal', false)
        }
      });
    }, */
    del() {
      this.$Modal.confirm({
        title: '温馨提示',
        okText: '确定',
        content: '是否删除该SPU？',
        onOk: () => {
          let temp = this.firstProductInfo.productGoodsList.map(k => {
            return k.productGoodsId
          })
          let reqParams = {
            productGoodsIds: temp
          }
          this.axios.post(api.productGoods_batchDelete, reqParams).then((res) => {
            if (res.data.code === 0) {
              this.$Message.success(res.data.message);
              this.turnBack();
              this.turnUpdate();
            } else {
              this.$Message.error(res.data.message)
            }
          });
        }
      });
    },
    // 打开选择水洗唛word文件弹窗
    opentCheckFile() {
      if (!this.$refs.washedUploadRef || !this.$refs.washedUploadRef.$el) return;
      const demo = this.$refs.washedUploadRef.$el.querySelector('.ivu-upload-select');
      if (!demo) return;
      demo.click();
    },
    // 水洗唛PDF文件上传
    washedUploadBefore(file) {
      if (this.isWashedUploadLoading || this.isDisabled) return false;
      if (['application/pdf', 'image/jpg', 'image/png', 'image/jpeg'].includes(file.type)) {
        this.isWashedUploadLoading = true;
        let newForm = new FormData(); // 创建form对象
        newForm.append('files', file);
        const uploadUrl = `${this.uploadFilesUrl}&random=${(Math.random()).toString().substring(2, 5) + (new Date().getTime()).toString()}`;
        this.axios.post(uploadUrl, newForm).then(res => {
          if (!res.data || res.data.code != 0) {
            this.isWashedUploadLoading = false;
            return;
          }
          this.$set(this.productInfo, 'washedLabelPdfPath', res.data.datas[0]);
          this.$set(this.productInfo, 'washedLabelPdfName', file.name);
          if (['application/pdf'].includes(file.type)) {
            this.$common.getPdfRes({
              pdfUrl: `./filenode/s${res.data.datas[0]}`,
              pageNumber: 1,
              scale: 10
            }).then(img => {
              this.pdfFirstImgPreview = img;
            }).finally(() => {
              this.isWashedUploadLoading = false;
            })
          } else {
            this.pdfFirstImgPreview = `./filenode/s${res.data.datas[0]}`;
            this.isWashedUploadLoading = false;
          }
        }).catch(() => {
          this.isWashedUploadLoading = false;
        })
        return false;
      }
      this.$Message.error('文件格式不对，请上传 PDF 文件或 PNG、JPG 类型的图片');
      return false;
    },
    // 移除水洗唛PDF文件
    removeWashedPdf() {
      this.$Modal.confirm({
        width: 500,
        title: '操作提示',
        content: '<div>确认删除水洗唛文件？</div><div style="font-size:12px;color:#f60;">注意：删除后需要保存才生效</div>',
        onOk: () => {
          this.$set(this.productInfo, 'washedLabelPdfPath', null);
          this.$set(this.productInfo, 'washedLabelPdfName', null);
        },
        onCancel: () => { }
      })
    },
    // 水洗唛PDF文件预览 productInfo.washedLabelPdfPath
    previewWashedPdf (viewUrl) {
      if (this.$common.isEmpty(viewUrl)) return;
      const suffix = viewUrl.substring(viewUrl.lastIndexOf('.'), viewUrl.length);
      if (suffix.toLocaleLowerCase() == '.pdf') {
        this.axios.get(`./filenode/s${viewUrl}`, { responseType: 'blob' }).then(res => {
          this.$common.blobToBase64(res.data || res.resData).then(data => {
            const fileBold = this.$common.base64ToBlob(data, 'application/pdf');
            this.$common.previewFile(fileBold);
          })
        })
      } else {
        window.open(`./filenode/s${viewUrl}`);
      }
    },
    // 图片预览
    previewImg(imgUrl) {
      window.open(imgUrl);
    },
    // 移除尺码图
    removePlanImg() {
      if (this.$common.isEmpty(this.productInfo)) return;
      const imgUrl = this.dimensionPlan.substring(this.filenodeViewTargetUrl.length);
      // 使用 map 生成新数组，触发 Vue 响应式追踪
      this.multiLangImageData = this.multiLangImageData.map(item => {
        if (item.language === 'common') {
          return {
            ...item,
            images: item.images.filter(img => img.path !== imgUrl)
          };
        }
        return { ...item };
      });

      if (!this.$common.isEmpty(this.productInfo.productImageTypeList)) {
        this.productInfo.productImageTypeList = [];
      }
    },
    // 验证外包装
    validateOutPack(rule, value, callback) {
      if (this.isDisabled) return callback();
      if (!this.$common.isEmpty(value) && value.trim().length > 200) {
        return callback(new Error('输入字符超出规定，最多200字符'));
      }
      return callback();
    },
    turnBack() { // 关闭
      this.initFinished = false;
      Object.keys(this.pageTagView).forEach(key => {
        this.pageTagView[key] = false;
      });
      this.$refs['productInfo'] && this.$refs['productInfo'].resetFields();
      this.$refs['attributeDome'] && this.$refs['attributeDome'].resetFields();
      this.locationErrorInput('baseInfo', '', true);
      this.productInfo = this.deepCopy(this.productInfoPrototype);
      this.oldAttrChange = false;
      this.skuData = [];
      this.skuPropertyList = [];
      this.classifyTalg = 'edit';
      this.$emit('goBack');
      this.$emit('update:editProductModal', false)
    },
    turnUpdate() {
      this.$emit('updateList');
    },
    // 刷新列表
    refreshList (res) {
      this.$emit('refreshList', res);
      this.getGpsrInfo(this.pageProductGoodsId);
    },
    /** 将图片路径插入 productImages 的指定语言分组，分组不存在时自动创建，并同步到 multiLangImageData */
    pushImageToCommonGroup(path, language = 'common') {
      if (!this.productInfo.productImages) {
        this.$set(this.productInfo, 'productImages', []);
      }
      const images = this.productInfo.productImages;
      const groupIndex = images.findIndex(g => g.language === language);
      if (groupIndex === -1) {
        // 分组不存在，创建新分组并插入（Vue 响应式追踪整个对象）
        images.push({ language, images: [{ path }] });
      } else {
        // 分组已存在，直接 push（数组变异方法已被 Vue 拦截）
        images[groupIndex].images.push({ path });
      }
      // 同步更新 multiLangImageData，使 productImageInfo 组件也能看到此图片
      const langIndex = this.multiLangImageData.findIndex(g => g.language === language);
      if (langIndex === -1) {
        this.multiLangImageData.push({ language, images: [{ path, imageType: null }] });
      } else {
        // 使用 map 替换生成新数组，确保 Vue 能追踪变化
        this.multiLangImageData = this.multiLangImageData.map((g, i) => {
          if (i !== langIndex) return { ...g };
          return { ...g, images: [...(g.images || []), { path, imageType: null }] };
        });
      }
    },
    uploadFilesSuccessModal(response, file, fileList) { // sku列表上传成功
      const path = file.response.datas[0];
      // 加入当前激活图套
      this.addImgToCurrentSet(path);
      this.pushImageToCommonGroup(path, this.skuImgActiveTab);
    },
    uploadExceedSizeModal() {
      this.$Message.error('文件大小超出限制，最大为10M');
    },
    uploadFilesErrorModal() {
      this.$Message.error('系统繁忙，请重新尝试');
    },
    handleFormatErrorModal() { // sku列表上传失败
      this.$Message.error('文件格式有误');
    },
    beforeUploadModal(file) {
      let selectedFiles = this.$refs.uploadProductGoodsImg.$refs.input.files;
      let curFileIndex = -1;
      for (let i = 0; i < selectedFiles.length; i++) {
        if (selectedFiles[i] === file) {
          curFileIndex = i;
        }
      }
      if (curFileIndex === 0 && selectedFiles.length > this.uploadMaxLength) {
        this.$Message.error('文件数量超出限制，一次最多可上传20张');
        return false;
      } else if (selectedFiles.length > this.uploadMaxLength) {
        return false;
      }
      let newForm = new FormData(); // 创建form对象
      newForm.append('files', file);
      this.uploadFilesTime && clearTimeout(this.uploadFilesTime);
      this.uploadFilesList.push(newForm);
      this.uploadFilesTime = setTimeout(() => {
        this.isUploading = true;
        this.uploadFilesCalLback = (arr) => {
          arr.forEach((newres) => {
            const path = newres.data.datas[0];
            // 加入当前激活的 SKU 图套
            this.addImgToCurrentSet(path);
            // 同步到 SPU 图库当前激活语言分组
            this.pushImageToCommonGroup(path, this.skuImgActiveTab);
          });
          this.$nextTick(() => {
            this.uploadFilesCalLback = () => { }
          })
        }
      }, 300);
      return false;
    },
    // 按顺序上传
    uploadFilesListHand() {
      this.uploadFilesLoading = true;
      const awaitList = this.uploadFilesList.map(file => {
        return this.axios.post(`${this.uploadFilesUrl}&random=${(Math.random()).toString().substring(2)}`, file)
      })
      Promise.all(awaitList).then(arr => {
        this.uploadFilesCalLback(arr);
        this.uploadFilesList = [];
        this.isUploading = false;
        this.uploadFilesLoading = false;
      }).catch(() => {
        // this.$Message.error('系统繁忙，请重新尝试');
        this.uploadFilesList = [];
        this.isUploading = false;
        this.uploadFilesLoading = false;
      });
    },
    initProductInfo(productInfo) { // 初始化商品信息
      return new Promise((resolve, reject) => {
        this.productInfo = {
          ...productInfo,
          checkType: this.$common.isEmpty(productInfo.checkType) ? '0' : productInfo.checkType.toString(),
          descriptionBOList: productInfo.descriptionBOList || [],
          productImages: [],
          productGoodsList: [],
          deliveryInterval: productInfo.deliveryInterval || 1,
          attributeFomNew: {
            attributeValueQOList: [],
            productCategoryId: '',
            productId: ''
          }
        };
        const includeKey = ['materialCnDesc', 'materialEnDesc', 'usageCnDesc', 'usageEnDesc'];
        includeKey.forEach(key => {
          this.$set(this.productInfo, key, productInfo[key] || '');
        });
        // 初始化 商品描述数据
        this.textInit(productInfo.descriptionBOList || [], productInfo.productId);
        // 处理质检数据
        if (productInfo.productQualityMeasureList && productInfo.productQualityMeasureList.length > 0) {
          let pos = [];
          productInfo.productQualityMeasureList.forEach((n, i) => {
            if (i === 0) {
              pos.push({
                measureName: n.measureName,
                measureVal: [
                  {
                    itemName: n.itemName,
                    itemValue: n.itemValue
                  }
                ]
              });
            } else {
              pos.forEach((m, t) => {
                if (m.measureName === n.measureName) { // 类目一致
                  m.measureVal.push({
                    itemName: n.itemName,
                    itemValue: n.itemValue
                  });
                } else if (t === pos.length - 1 && m.measureName !== n.measureName) {
                  pos.push({
                    measureName: n.measureName,
                    measureVal: [
                      {
                        itemName: n.itemName,
                        itemValue: n.itemValue
                      }
                    ]
                  });
                }
              });
            }
          });
          this.categoryList = pos;
        } else {
          this.categoryList = [];
        }
        // End
        if (!this.$common.isEmpty(productInfo.multiLangImageList)) {
          let selfPic = [];
          // let productPath = [];
          let isPush = this.$common.isEmpty(this.productInfo.productImageTypeList);
          let imageTypeList = productInfo.multiLangImageList.find((item) => {
            return item.language === 'common';
          }) || {};
          (imageTypeList.images || []).forEach((productImage) => {
            if ([2, 3, 4, '2', '3', '4'].includes(productImage.imageType) && isPush) {
              selfPic.push({
                path: productImage.path,
                imageType: productImage.imageType
              });
            }
          });
          this.multiLangImageData = productInfo.multiLangImageList;
          if (isPush) {
            this.$set(this.productInfo, 'productImageTypeList', selfPic);
          }
        }
        this.removeTableColumn();
        resolve();
      })
    },
    initProductGoods(productGoodsList) { // 初始化货品信息
      let self = this;
      productGoodsList.forEach((productGoods, index) => {
        let newProductGoods = {
          ...(this.$common.copy(productGoods)),
          productGoodsTags: [],
          // productGoodsImages: productGoods.productGoodsImages || [],
          isAssemble: productGoods.isAssemble === 1, // 是否组装
          editStatus: false, // 是否重新编辑
          productTypeListValue: (productGoods.productGoodsAcceptableTypes || []).map(i => {
            return i.typeCode;
          })
        };
        // 组装信息
        if (productGoods.productGoodsAssembles) {
          let pos = [];
          let pic = null;
          productGoods.productGoodsAssembles.forEach((m, t) => {
            pic = m.productGoodsImages ? m.productGoodsImages[0].path : null;
            pos.push({
              productGoodsId: m.materialProductGoodsId,
              sku: m.sku,
              skc: m.skc,
              name: m.cnName,
              value: m.productGoodsSpecifications,
              quantity: m.quantity,
              pictureUrl: pic
            });
          });
          self.addAssembleData = pos;
          self.addData = pos;
        }
        let productGoodsTagNames = [];
        // let productGoodsImagePaths = [];
        let productGoodsTags = productGoods.productGoodsTags;
        // let productGoodsImages = productGoods.productGoodsImages;
        if (productGoodsTags) {
          productGoodsTags.forEach((productGoodsTag, i) => {
            productGoodsTagNames.push(productGoodsTag.tagName);
            if (self.customProductTagList.indexOf(productGoodsTag.tagName) === -1) {
              self.customProductTagList.push(productGoodsTag.tagName);
            }
          });
        }
        newProductGoods.productGoodsTags = productGoodsTagNames;
        // 初始化规格属性
        if (productGoods.productGoodsSpecifications) {
          let skuList = this.$common.copy(self.skuPropertyList);
          productGoods.productGoodsSpecifications.forEach((productGoodsSpecification, i) => {
            this.$set(this.specificationsObj, `${productGoodsSpecification.name}${productGoodsSpecification.value}`, productGoodsSpecification);
            if (!skuList[i]) {
              skuList[i] = {
                name: productGoodsSpecification.name,
                invalid: false,
                values: [productGoodsSpecification.value],
                selected: true,
                isEdit: true
              };
            } else if (skuList[i].values.indexOf(productGoodsSpecification.value) === -1) {
              skuList[i].values.push(productGoodsSpecification.value);
              skuList[i].selected = true;
            }
          });
          self.skuPropertyList = skuList;
        }
        self.productInfo.productGoodsList.push(newProductGoods);
      });
      if (self.productInfo.productGoodsList.length === 1 && self.productInfo.productGoodsList[0].productGoodsAcceptableTypes) {
        self.productTypeListValue = self.productInfo.productGoodsList[0].productGoodsAcceptableTypes.map(i => {
          return i.typeCode;
        });
      }
      self.skuData = self.deepCopy(self.productInfo.productGoodsList);
    },
    getProductCategoryTree(productCategoryListData, parentId, currentProductCategoryId) { // 组装商品分类树
      // let self = this;
      let tree = [];
      let children;
      if (!productCategoryListData) {
        return [];
      }
      productCategoryListData.forEach((n, i) => {
        if (n.parentId === parentId) {
          n.title = n.cnName;
          n.expand = true;
          if (n.productCategoryId === currentProductCategoryId) {
            this.treeSelectCategoryValue = currentProductCategoryId;
          } else {
            n.selected = false;
          }
          children = this.getProductCategoryTree(productCategoryListData, n.productCategoryId, currentProductCategoryId);
          if (children.length > 0) {
            n.children = children;
          }
          this.$set(this.treeSelectCategoryJson, n.productCategoryId, n);
          tree.push(n);
        }
      });
      return tree;
    },
    initCategoryTree(currentProductCategoryId) { // 初始化分类树
      let productCategoryTree = this.getProductCategoryTree(this.$common.copy(this.productCategoryListData), null, currentProductCategoryId);
      let noCategory = {
        title: '未分类',
        productCategoryId: 'noCategory'
      };
      this.treeSelectCategoryJson['noCategory'] = JSON.parse(JSON.stringify(noCategory))
      if (currentProductCategoryId === null || currentProductCategoryId == '') {
        this.treeSelectCategoryValue = 'noCategory'
        noCategory.selected = true;
      }
      productCategoryTree.unshift(noCategory);
      this.$set(this.productCategoryTree[0], 'children', productCategoryTree);
      this.treeSelectCategoryJson['productCategoryId1'] = JSON.parse(JSON.stringify(this.productCategoryTree[0]))
      this.$nextTick(() => {
        this.initGetTreeData = false;
        this.categoryChange = true;
        this.disabledTreeItem();
      })
    },
    initYmsCategoryTree(ymsProductCategoryId) {
      if (this.originalCategoryData) {
        let obj = this.originalCategoryData.filter(i => i.ymsProductCategoryId === ymsProductCategoryId);
        this.$refs.productCategoryTree1.treeSelectGetValue(obj);
      }
    },
    editSkuImage(index) { // 编辑SKU图片
      const productGoodsId = this.productInfo.productGoodsList[index].productGoodsId;
      if (!productGoodsId) {
        this.$Modal.confirm({
          title: '提示',
          content: '请先点击右上角“保存”按钮保存SKU后再操作',
          okText: '确定',
          cancelText: '取消',
          onOk: () => {}
        });
        return;
      }
      this.renderModifyProductGoodsImgModal = true;
      this.$nextTick(() => {
        this.modifyProductGoodsImgModal = true;
        this.skuImgActiveTab = 'common';
        this.skuImgSpuFilterLang = 'common';
        this.isSynchroAllSkcModel = { common: false, en: false, fr: false, de: false, ru: false, nl: false };
        this.isSynchroAllSkcColor = { common: false, en: false, fr: false, de: false, ru: false, nl: false };
        this.skuActiveSetId = {};
        this.skuImageSetList = [];
        // 加载图套列表
        this.loadImageSetList(productGoodsId);
      });
      this.editIndex = index;
    },
    /** 加载SKU图套列表 */
    loadImageSetList(productGoodsId) {
      this.skuImageSetLoading = true;
      this.axios.get(api.get_productGoodsImageSetList + productGoodsId).then(res => {
        if (res && res.data && res.data.code === 0) {
          this.skuImageSetList = (res.data.datas || []).map(item => ({
            ...item,
            productGoodsImageSetId: String(item.productGoodsImageSetId || ''),
            images: (item.images || []).map(img => (typeof img === 'string' ? img : img.path))
          }));
        } else {
          this.skuImageSetList = [];
        }
      }).catch(() => {
        this.skuImageSetList = [];
      }).finally(() => {
        this.skuImageSetLoading = false;
      });
    },
    /** 切换图套 */
    switchImageSet(setId) {
      this.$set(this.skuActiveSetId, this.skuImgActiveTab, setId);
    },
    /** 打开新增图套弹框 */
    openAddSetModal() {
      this.skuAddSetIsEdit = false;
      this.skuAddSetEditTarget = null;
      this.skuAddSetName = '';
      this.skuAddSetType = '1';
      this.skuAddSetNameErr = '';
      this.skuAddSetModal = true;
    },
    /** 打开编辑图套弹框 */
    openEditSetModal(imgSet) {
      this.skuAddSetIsEdit = true;
      this.skuAddSetEditTarget = imgSet;
      this.skuAddSetName = imgSet.setName || '';
      this.skuAddSetType = String(imgSet.setType || '1');
      this.skuAddSetNameErr = '';
      this.skuAddSetModal = true;
    },
    /** 获取图套类型标签文字 */
    getSetTypeLabel(setType) {
      const map = { '1': '网图', '2': '非实拍自修', '3': '实拍自修' };
      return map[String(setType)] || String(setType);
    },
    /** 获取图套类型 badge 颜色 */
    getSetTypeBadgeColor(setType) {
      const map = { '1': '#f90', '2': '#19be6b', '3': '#19be6b' };
      return map[String(setType)] || '#999';
    },
    /** 确认新增/编辑图套 */
    confirmAddImageSet() {
      if (!this.skuAddSetName.trim()) {
        this.skuAddSetNameErr = '图套名称不能为空';
        return;
      }
      this.skuAddSetNameErr = '';
      const productGoodsId = this.productInfo.productGoodsList[this.editIndex].productGoodsId;
      if (this.skuAddSetIsEdit && this.skuAddSetEditTarget) {
        // 编辑模式：调用 update 接口
        const payload = {
          productGoodsImageSetId: this.skuAddSetEditTarget.productGoodsImageSetId,
          productGoodsId,
          language: this.skuImgActiveTab,
          setName: this.skuAddSetName.trim(),
          setType: this.skuAddSetType
        };
        this.axios.post(api.update_productGoodsImageSet, payload).then(res => {
          if (res && res.data && res.data.code === 0) {
            this.skuAddSetEditTarget.setName = payload.setName;
            this.skuAddSetEditTarget.setType = payload.setType;
            this.$Message.success('图套信息已更新');
          }
        })
      } else {
        // 新增模式：调用 add 接口
        const payload = {
          productGoodsId,
          language: this.skuImgActiveTab,
          setName: this.skuAddSetName.trim(),
          setType: this.skuAddSetType
        };
        this.axios.post(api.add_productGoodsImageSet, payload).then(res => {
          if (res && res.data && res.data.code === 0) {
            const newSet = {
              productGoodsImageSetId: res.data.datas || String(Date.now()),
              setName: payload.setName,
              setType: payload.setType,
              language: payload.language,
              images: []
            };
            this.skuImageSetList.push(newSet);
            this.$set(this.skuActiveSetId, this.skuImgActiveTab, newSet.productGoodsImageSetId);
            this.$Message.success('新增图套成功');
          }
        })
      }
      this.skuAddSetModal = false;
    },
    /** 删除图套 */
    delImageSet(imgSet) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确认删除图套「${imgSet.setName}」吗？此操作不可撤销。`,
        onOk: () => {
          if (!imgSet.productGoodsImageSetId) return;
          const targetId = String(imgSet.productGoodsImageSetId);
          this.axios.post(api.del_productGoodsImageSet + targetId).then(res => {
            if (res && res.data && res.data.code === 0) {
              const idx = this.skuImageSetList.findIndex(s => String(s.productGoodsImageSetId) === targetId);
              if (idx !== -1) this.skuImageSetList.splice(idx, 1);
              // 若删除的是当前激活图套，重置到第一个
              if (String(this.skuActiveSetId[this.skuImgActiveTab]) === targetId) {
                const next = this.currentLangImageSets[0];
                this.$set(this.skuActiveSetId, this.skuImgActiveTab, next ? next.productGoodsImageSetId : null);
              }
              this.$Message.success('图套已删除');
            } else {
              this.$Message.error((res.data && res.data.message) || '删除图套失败');
            }
          });
        }
      });
    },
    /** 将图片加入当前图套（仅本地操作，不请求接口） */
    addImgToCurrentSet(path) {
      if (!this.currentActiveSet) {
        this.$Modal.confirm({
          title: '提示',
          content: '请先选择或创建图套',
          okText: '确定',
          cancelText: '取消',
          onOk: () => {}
        });
        return;
      }
      const set = this.currentActiveSet;
      if (!set.images) this.$set(set, 'images', []);
      if (!set.images.includes(path)) {
        set.images.push(path);
      }
    },
    /** 删除当前图套中的图片 */
    removeSetImg(imgPath) {
      if (!this.currentActiveSet) return;
      const set = this.currentActiveSet;
      const idx = (set.images || []).indexOf(imgPath);
      if (idx !== -1) set.images.splice(idx, 1);
    },
    /** 设置当前图套主图（置顶） */
    setSetPrimaryImg(imgPath) {
      if (!this.currentActiveSet) return;
      const set = this.currentActiveSet;
      const idx = (set.images || []).indexOf(imgPath);
      if (idx !== -1) set.images.splice(idx, 1);
      set.images.unshift(imgPath);
    },
    editDistribution({ index, row }) { // 编辑分销
      this.distributionInfo = {
        index: index,
        row: row
      }
      this.$nextTick(() => {
        this.distributionVisible = true;
      })
    },
    editAssemble(index) { // 编辑变参商品组装信息
      this.$refs.addAssembleModal.matchingGoodsStatus = true;
      this.$refs.addAssembleModal.matchingGoodsModal = true;
      this.$refs.addAssembleModal.getNormalGoodsData();
      this.openType = 2; // 变参商品
      this.editAssembleIndex = index; // 记录当前下标
      let value = this.productInfo.productGoodsList[index].productGoodsAssembles;
      if (value) {
        this.$refs.addAssembleModal.matchingGoodsList = value;
        this.$refs.addAssembleModal.openStatus = true;
      }
    },
    addTabData(val) { // 接收子组件传值
      this.productInfo.productGoodsList[this.editAssembleIndex].productGoodsAssembles = val;
    },
    addQuality() { // 新增质检类目
      this.categoryList.push({
        measureName: null,
        measureVal: [
          {
            itemName: null,
            itemValue: null
          }
        ]
      });
    },
    addQualityItem(index) { // 给当前类目添加质检项
      this.categoryList[index].measureVal.push({
        itemName: null,
        itemValue: null
      });
    },
    delQualityItem(index) { // 删除当前类目
      this.categoryList.splice(index, 1);
    },
    delMeasureItem(index, t) { // 删除当前质检项
      this.categoryList[index].measureVal.splice(t, 1);
    },
    // 获取尺码模板的数据
    getTemplateData(ymsProductCategoryId) {
      this.axios.get(api.get_ymsProductSizeTemplate + `${ymsProductCategoryId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            this.hideSizeChart = true;
            this.sizeJsonData = data;
            if (this.classifyTalg === 'change') {
              this.handlerTemplate(data);
              if (this.skuPropertyList.length > 0) {
                this.sizeChartdata = [];
                this.skuPropertyList.map((item) => {
                  if (item.name === '尺码') {
                    item.values.map((ele) => {
                      this.sizeChartdata.push(Object.assign({}, { size: ele }, this.templateObj));
                    });
                  }
                });
              }
            }
          } else {
            // 没有绑定尺码模板时，隐藏尺码表
            this.sizeChartdata = [];
            this.hideSizeChart = false;
          }
        }
      });
    },
    // 处理尺码表的单位
    handlerUnit(data, value) {
      let children = [];
      let obj = {};
      if (data.productSizeUnitBos.length > 0) {
        let list = data.productSizeUnitBos;
        list.map((item) => {
          if (item.isDefault === 1) {
            this.templateObj[value + '_defaultUnitName'] = item.name;
            obj = {
              title: item.name,
              key: value + '_defaultValue',
              align: 'center',
              render: (h, params) => {
                return h('InputNumber', {
                  props: {
                    value: params.row[value + '_defaultValue'],
                    min: 0,
                    disabled: (() => {
                      return this.isDisabled;
                    })()
                  },
                  on: {
                    'on-change': val => {
                      this.sizeChartdata[params.index][value + '_defaultValue'] = val;
                    }
                  }
                });
              }
            };
          } else {
            obj = {
              title: item.name,
              key: value + '_value',
              align: 'center',
              render: (h, params) => {
                let num = params.row[value + '_value'];
                let unitValue = params.row[value + '_defaultValue'];
                // 英寸转化厘米
                if (item.name === 'cm') {
                  if (unitValue > 0) {
                    num = unitValue * 2.54;
                    // Math.floor(num * 100) / 100;
                    num = num.toFixed(2);
                  }
                } else {
                  // 厘米转化成英寸
                  if (unitValue > 0) {
                    num = unitValue * 0.393701;
                    // Math.floor(num * 100) / 100;
                    num = num.toFixed(2);
                  }
                }
                this.sizeChartdata[params.index][value + '_value'] = Number(num) === 0
                  ? null
                  : Number(num);
                return h('span', num);
              }
            };
          }
          children.push(obj);
        });
        return children;
      }
    },
    // 处理尺码表的数据
    handlerTemplate(data, ymsProductCategoryId) {
      // 查看的时候
      this.sizeChartColumns = [];
      const fixColumn = [
        {
          title: 'UK Size',
          key: 'ukSize',
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                value: isNaN(Number(params.row.ukSize)) ? 0 : params.row.ukSize
              },
              style: {
                width: '70px'
              },
              on: {
                'on-change'(e) {
                  if (!isNaN(Number(e.target.value))) {
                    this.sizeChartdata[params.index]['ukSize'] = e.target.value;
                  } else {
                    this.sizeChartdata[params.index]['ukSize'] = 0;
                  }
                }
              }
            });
          }
        }, {
          title: 'EU Size',
          key: 'euSize',
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                value: isNaN(Number(params.row.euSize)) ? 0 : params.row.euSize
              },
              style: {
                width: '70px'
              },
              on: {
                'on-change'(e) {
                  if (!isNaN(Number(e.target.value))) {
                    this.sizeChartdata[params.index]['euSize'] = e.target.value;
                  } else {
                    this.sizeChartdata[params.index]['euSize'] = 0;
                  }
                }
              }
            });
          }
        }, {
          title: 'US Size',
          key: 'usSize',
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                value: isNaN(Number(params.row.usSize)) ? 0 : params.row.usSize
              },
              style: {
                width: '70px'
              },
              on: {
                'on-change'(e) {
                  if (!isNaN(Number(e.target.value))) {
                    this.sizeChartdata[params.index]['usSize'] = e.target.value;
                  } else {
                    this.sizeChartdata[params.index]['usSize'] = 0;
                  }
                }
              }
            });
          }
        }];

      if (this.classifyTalg === 'look' || this.classifyTalg === 'edit') {
        // 判断当前的单位
        this.axios.get(api.get_ymsProductSizeTemplate + `${ymsProductCategoryId}`).then(response => {
          if (response.data.code === 0) {
            let unitData = response.data.datas;
            if (data) {
              let size = {
                title: 'Tag Size',
                key: 'sizeCode',
                align: 'center',
                render: (h, params) => {
                  return h('Input', {
                    props: {
                      size: 'small',
                      value: params.row.sizeCode
                    },
                    style: {
                      width: '70px'
                    }
                  });
                }
              };
              // 部位
              data.forEach((item) => {
                let obj = {};
                this.sizeChartColumns = [];
                item.sizeDetailBos.forEach((ele, index) => {
                  item['partsName_' + index] = ele.partsName;
                  item['unitName_' + index] = ele.unitName;
                  item['unitValue_' + index] = ele.unitValue;
                  this.editObj['partsName_' + index] = ele.partsName;
                  this.editObj['unitName_' + index] = ele.unitName;
                  this.editObj['unitValue_' + index] = null;
                  if (unitData.productSizeUnitBos.length > 0) {
                    let list = unitData.productSizeUnitBos;
                    let objs = {};
                    let children = [];
                    list.forEach((item) => {
                      if (item.isDefault === 1) {
                        objs = {
                          title: item.name,
                          key: 'unitValue_' + index,
                          align: 'center',
                          render: (h, params) => {
                            let unitValue = Number(params.row['unitValue_' + index]);
                            return h('InputNumber', {
                              props: {
                                value: unitValue,
                                min: 0,
                                disabled: (() => {
                                  return this.isDisabled;
                                })()
                              },
                              on: {
                                'on-change': val => {
                                  this.sizeChartdata[params.index]['unitValue_' + index] = val;
                                }
                              }
                            });
                          }
                        };
                      } else {
                        objs = {
                          title: item.name,
                          key: 'unitValue_' + index,
                          align: 'center',
                          render: (h, params) => {
                            // 英寸转化厘米
                            let unitValue = Number(params.row['unitValue_' + index]);
                            let num = '';
                            if (item.name === 'cm') {
                              if (unitValue > 0) {
                                num = unitValue * 2.54;
                                // Math.floor(num * 100) / 100;
                                num = num.toFixed(2);
                              }
                            } else {
                              // 厘米转化成英寸
                              if (unitValue > 0) {
                                num = unitValue * 0.393701;
                                // Math.floor(num * 100) / 100;
                                num = num.toFixed(2);
                              }
                            }
                            return h('span', num);
                          }
                        };
                      }
                      children.push(objs);
                      obj = {
                        title: ele.partsName,
                        align: 'center',
                        maxWidth: 220,
                        children: children
                      };
                    });
                  }
                  this.sizeChartColumns.push(obj);
                });
              });
              this.sizeChartColumns.unshift(size, ...fixColumn);
              this.sizeChartdata = data;
            }
          }
        });
      } else {
        // 切换选取其他云卖分类的时候
        if (data) {
          let size = {
            title: 'Tag Size',
            key: 'size',
            align: 'center',
            render: (h, params) => {
              return h('Input', {
                props: {
                  value: params.row.size,
                  disabled: true
                },
                style: {
                  width: '100px'
                }
              });
            }
          };
          // 部位
          let place = {};
          if (data.productSizePartsBos.length > 0) {
            data.productSizePartsBos.map((item, index) => {
              this.templateObj[item.ymsProductSizePartsId + '_partName'] = item.name;
              this.templateObj[item.ymsProductSizePartsId + '_defaultValue'] = null;
              this.templateObj[item.ymsProductSizePartsId + '_value'] = null;
              place = {
                title: item.name,
                align: 'center',
                maxWidth: 220,
                children: this.handlerUnit(data, item.ymsProductSizePartsId)
              };
              this.sizeChartColumns.push(place);
            });
          }
          this.sizeChartColumns.unshift(size, ...fixColumn);
        }
      }
    },
    // 处理添加尺码属性的数据
    handlerSizeData(data) {
      if (this.classifyTalg === 'edit') {
        if (data) {
          if (data.name === '尺码') {
            data.values.map((ele) => {
              this.sizeChartdata.push(Object.assign({}, this.editObj, { sizeCode: ele, ukSize: '', euSize: '', usSize: '' }));
            });
          }
          this.sizeChartdata = this.uniqueFunc(this.sizeChartdata, 'sizeCode');
        }
      } else if (this.classifyTalg === 'change') {
        this.sizeChartdata = [];
        if (data) {
          if (data.name === '尺码') {
            data.values.map((ele) => {
              this.sizeChartdata.push(Object.assign({}, { size: ele }, this.templateObj));
            });
          }
        }
      }
    },
    // 获取分类属性值
    getAttributeData(attr, type) {
      this.getAttributeValueList(attr).then(res => {
        (res.attributeClassifyVOList || []).forEach(item => {
          if (type) {
            if (item.type == 0) {
              const itemVal = (item.attributeValueList || []).filter(op => {
                return res.attributeValueIds.includes(op.attributeValueId)
              }).map(vItem => {
                return vItem.attributeValueId
              })
              const val = itemVal.join('')
              item.attributeValueIdList = isNaN(val) ? val : val ? Number(val) : ''
            } else {
              item.attributeValueIdList = (item.attributeValueList || []).filter(op => {
                return res.attributeValueIds.includes(op.attributeValueId)
              }).map(vItem => {
                return vItem.attributeValueId
              })
            }
          } else {
            item.attributeValueIdList = item.type == 0 ? '' : []
          }
          item.valueVOList = item.attributeValueList
        })
        this.$set(this.attributeFom, 'attributeValueQOList', res.attributeClassifyVOList || []);
        this.$set(this.productInfo, 'attributeFomNew', this.attributeFom);
      })
    },
    // 所属分类下拉
    getAttributeValueList(attr) {
      return new Promise(resolve => {
        this.axios.post(api.query_findAttribute, {
          productCategoryId: attr.productCategoryId,
          productId: attr.productId
        }).then(res => {
          if (res.data.code == 0) {
            resolve(res.data.datas || []);
            return;
          }
          resolve([])
        }).catch(() => {
          resolve([])
        })
      })
    },
    // 咨询是否同步数据
    synchronousRemind(resolve) {
      if (!this.permission.synchronous) {
        this.$emit('update:editProductModal', false);
        this.$parent.$parent.pageParamsStatus = true;
        return
      }
      this.$Modal.confirm({
        width: 500,
        title: '商品信息变更',
        content: `是否自动同步商品信息至Listing？
        <div style="margin-top:10px; color:#f20;">
          注意：该操作会同步覆盖Listing中的商品基础资料，所有基础信息，多属性信息，属性信息，以ERP系统为主。
        </div>`,
        onOk: () => {
          this.turnBack();
          this.turnUpdate();
          this.$parent.$parent.pageParamsStatus = true;
          // 同步商品信息
          this.axios.post(api.synProductInfoToListing, {
            productInfoIds: [resolve.productId],
            type: [0]
          }).then(res => {
            // if (res && res.data && res.data.code == 0 && res.data.datas) {
            if (res && res.data && res.data.code == 0) {
              // const failTotal = res.data.datas.addFailNum + res.data.datas.updateFailNum;
              // if (failTotal == 0) {
              //   this.$Message.success('同步数据成功！')
              // } else {
              //   this.$Message.error('同步商品信息失败')
              // }
              this.$Message.success('同步商品信息操作完成');
            } else {
              this.$Message.error('同步商品信息操作失败')
            }
          }).catch(() => {
            this.$Message.error('同步商品信息操作失败')
          })
        },
        onCancel: () => {
          this.$parent.$parent.pageParamsStatus = true;
          this.turnBack();
          this.turnUpdate();
        }
      })
    },
    // 编辑多属性（委托给子组件）
    editAttributes(info) {
      // 确保多属性 Tab 已渲染（pageTagView['multiattribute'] 为 true）
      if (!this.pageTagView['multiattribute']) {
        this.pageEditTag = 'multiattribute';
      }
      this.$nextTick(() => {
        if (this.$refs.productMultiattributeRef) {
          this.$refs.productMultiattributeRef.editAttributes(info);
        }
      });
    },
    // 绑定尺码组弹窗
    bindSizeGroupNo() {
      this.$Modal.confirm({
        title: '操作提示',
        content: '请先绑定商品尺码组',
        onOk: () => {
          this.bindSizeModuleData = {
            sizeList: this.$common.copy(this.sizeList),
            skuData: this.$common.copy(this.skuData),
            productInfo: this.$common.copy(this.productInfo)
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.bindSizeGroupVisible = true;
            }, 310)
          })
        },
        onCancel: () => {
          this.$nextTick(() => {
            setTimeout(() => {
              this.editAttributes({});
            }, 310)
          })
        }
      });
    },
    // 获取颜色
    getColorList() {
      return new Promise((resolve) => {
        this.axios.get(api.getColorList, { hiddenError: true }).then(res => {
          if (res.data.code === 0) {
            this.colorList = res.data.datas;
          }
        }).finally(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 获取尺码
    getSizeList() {
      return new Promise((resolve, reject) => {
        let productCategoryId = this.treeSelectCategoryValue;
        let productType = null;
        let sizeType = null;
        this.productCategoryListData.forEach(k => {
          if (k.productCategoryId == productCategoryId) {
            sizeType = k.sizeType
            productType = k.productType
          } else if (k.children) {
            k.children.forEach(j => {
              if (j.productCategoryId == productCategoryId) {
                sizeType = j.sizeType
                productType = j.productType
              }
            })
          }
        })
        this.sizeTypeFar = sizeType;
        this.productTypeFar = productType;
        // 判断商品类型： 服饰 家居 饰品
        if ((productType == 0 || productType == 2) && (sizeType || sizeType == 0)) {
          this.columnSizeOrModel = 'Size'
        } else {
          this.columnSizeOrModel = 'Model'
        }
        if (sizeType || sizeType === 0) {
          // this.axios.get(api.getSizeList, { params: { sizeTypeId: sizeType } }).then(res => {
          this.axios.get(api.getSizeHistory, { params: { erpProductId: this.productId } }).then(res => {
            if (res.data.code === 0) {
              let list = [];
              let datas = res.data.datas;
              for (let i = 0; i < datas.length; i++) {
                let temp = {
                  ...datas[i],
                  value: 'arr' + (i + 1),
                  label: '尺码组' + (i + 1),
                  children: datas[i].sizeList
                };
                list.push(temp);
              }
              for (let i in list) {
                for (let j in list[i].children) {
                  list[i].children[j].value = list[i].children[j].size;
                  list[i].children[j].label = list[i].children[j].size
                }
              }
              this.sizeList = list || []
            }
          });
        } else {
          this.sizeList = []
        }
        resolve();
      })
    },
    openSizeChart(type) {
      // if (!type) return;
      this.planType = type;
      const obj = { 1: 'chartModalVisible', 2: 'childVisible', 3: 'childVisible', 4: 'chartModalVisible' };
      if ([1, '1'].includes(type)) {
        this.getProductDetail();
      }
      this.$nextTick(() => {
        this[obj[type]] = true;
      })
    },
    getProductDetail() {
      return new Promise((resolve, reject) => {
        this.axios.get(api.queryLaPaProductGoodsInfo, {
          params: { productId: this.productInfo.productId }
        }).then((res) => {
          if (res.data.code === 0) {
            // 商品多属性(用于尺码图的左侧属性)
            this.$set(this.commodiAttr, 'laPaProductVariQuotationList', res.data.datas.laPaProductVariQuotationList || []);
            resolve(res.data.datas.attributeValueVOList || []);
          }
        }).catch(err => {
          reject(err);
        });
      })
    },
    // 禁用 所属分类下拉树
    disabledTreeItem() {
      return new Promise((resolve) => {
        const handTreeData = (arr, parent) => {
          if (!this.$common.isEmpty(parent) && parent.productCategoryId !== 'productCategoryId') {
            this.$set(parent, 'isDisabled', !parent.productChildType.includes(this.productTypeFar));
          }
          arr.forEach(item => {
            if (!this.$common.isEmpty(item.children)) {
              this.$set(item, 'productChildType', this.getChildAllType(item.children, item.productType));
              handTreeData(item.children, item);
            } else {
              if (item.productCategoryId !== 'productCategoryId') {
                this.$set(item, 'isDisabled', item.productType !== this.productTypeFar);
              }
            }
          });
          return arr;
        }
        this.productCategoryTree = handTreeData(this.$common.copy(this.productCategoryTree));
        // let tree = this.productCategoryTree[0].children;
        // tree.forEach(k => {
        //   if (k.children) {
        //     k.productType = k.children[0].productType
        //   } else {
        //     k.productType = null
        //   }
        //   if (k.productType !== this.productTypeFar) {
        //     this.$set(k, 'isDisabled', true)
        //   }
        //   if ((k.productType === '1' && this.productTypeFar === null) || (k.productType === null && this.productTypeFar === '1')) {
        //     this.$set(k, 'isDisabled', false)
        //   }
        // })
        resolve()
      })
    },
    // 获取子级所有 productType (包含自身)
    getChildAllType(arr, productType) {
      let list = [productType];
      arr.forEach(item => {
        list.push(item.productType);
        if (!this.$common.isEmpty(item.children)) {
          list = [...list, ...this.getChildAllType(item.children, item.productType)];
        }
      });
      return this.$common.arrRemoveRepeat(list).filter(f => !this.$common.isEmpty(f));
    },
    // 更新图片
    getSizePicture(data) {
      let list = [];
      let selfPic = [];
      const commonImages = this.productInfo.multiLangImageList.find(item => {
        return item.language === 'common';
      }) || {};
      const newImages = this.multiLangImageData.find(item => {
        return item.language === 'common';
      }) || {};
      const imgPathList = [...(commonImages.images || []), ...(this.productInfo.productImageTypeList || [])].filter(item => {
        return [2, 3, 4, '2', '3', '4'].includes(item.imageType);
      }).map(m => m.path);
      const getImages = (newImages.images || []).filter(item => {
        return !imgPathList.includes(item.path);
      });
      (data || []).forEach(item => {
        list.push(item.pictureUrl);
        if (![0, 1, '0', '1'].includes(item.pictureType)) {
          selfPic.push({
            path: item.pictureUrl,
            imageType: item.pictureType
          });
        }
      });
      // 使用 map 生成新数组，确保 Vue 能追踪变化；使用 selfPic 中已带 imageType 的图片替换纯路径列表
      const selfPicPaths = selfPic.map(p => p.path);
      const normalPics = list
        .filter(p => !selfPicPaths.includes(p))
        .map(p => ({ path: p, imageType: null }));
      const newSizePics = selfPic.concat(normalPics);
      this.multiLangImageData = this.multiLangImageData.map(item => {
        if (item.language === 'common') {
          return { ...item, images: getImages.concat(newSizePics) };
        }
        return { ...item };
      });
    },
    loadPicture() {
      // productInfo.productImages 为分组结构 [{language, images:[{path}]}]
      (this.productInfo.productImages || []).forEach(group => {
        (group.images || []).forEach(img => {
          let image = new Image();
          image.src = this.filenodeViewTargetUrl + img.path;
        });
      });
    },
    checkOldData() {
      /*
        1、当 productGoodsList 数组下的所有 productGoodsSpecifications 为空时即为旧数据
        2、当 productGoodsList 数组下的 productGoodsSpecifications 有非空存在时，并且数组 productGoodsSpecifications 中的 typeValueId 存在空值时即为旧数据
      */
      const getOldItem = this.firstProductInfo.productGoodsList.filter(f => {
        if (!this.$common.isEmpty(f.productGoodsSpecifications)) {
          const findItem = f.productGoodsSpecifications.find(item => {
            return this.$common.isEmpty(item.typeValueId);
          })
          return !this.$common.isEmpty(findItem);
        }
        return true;
      })
      this.isOldData = !this.$common.isEmpty(getOldItem);
    },
    getChildType(type) {
      this.type = type;
    },
    tableEditcontent(html) {
      this.$refs.descdomeue.tableEditcontent(html)
    },
    // 分销变更
    distributionConfirm(option) {
      this.$set(this.productInfo.productGoodsList[option.index], 'distributionPriceType', option.distributionPriceType);
      this.$set(this.productInfo.productGoodsList[option.index], 'distributionPriceValue', option.distributionPriceValue);
      // 同步到 skuData（通过更新 productGoodsList 并重新赋值触发 watch → emit，或直接 emit update:skuData）
      const newSkuData = this.deepCopy(this.skuData);
      if (newSkuData[option.index]) {
        newSkuData[option.index].distributionPriceType = option.distributionPriceType;
        newSkuData[option.index].distributionPriceValue = option.distributionPriceValue;
      }
      this.$emit('update:skuData', newSkuData);
    },
    // 验证质检比例
    validateCheckRate(rule, value, callback) {
      if (![1, '1'].includes(this.productInfo.checkType)) {
        return callback();
      }
      this.$nextTick(() => {
        let newVal = this.productInfo.checkRate;
        if (this.$common.isEmpty(newVal, true)) {
          return callback(new Error('请输入质检比例'));
        }
        this.$common.validatorMaxNumber(rule, newVal, callback);
      })
    },
    // 验证应检最少数量
    validateMinCheckNum (rule, value, callback) {
      if ([0, '0'].includes(this.productInfo.checkType)) {
        return callback();
      }
      this.$nextTick(() => {
        let newVal = this.productInfo.minCheckNum;
        this.$common.validatorMaxNumber(rule, newVal, callback);
      })
    },
    // 验证报关中文
    hsNameMaxVerify(rule, value, callback) {
      const newVal = this.$common.isEmpty(value) ? '' : value.trim();
      const regex = this.$regular.hasChinese;
      if (!this.$common.isEmpty(newVal) && !regex.test(newVal)) {
        return callback(new Error('必须包含中文'));
      }
      this.$common.strMaxVerify(rule, value, callback);
    },
    // 验证报关英文
    enNameMaxVerify(rule, value, callback) {
      const newVal = this.$common.isEmpty(value) ? '' : value.trim();
      // eslint-disable-next-line no-useless-escape
      const regex = this.$regular.hasEnglish;
      if (!this.$common.isEmpty(newVal) && !regex.test(newVal)) {
        return callback(new Error('必须包含英文'));
      }
      this.$common.strMaxVerify(rule, value, callback);
    },
    hsCodeVerify(rule, value, callback) {
      const newVal = this.$common.isEmpty(value) ? '' : value.trim();
      const regex = this.$regular.AllNumber;
      if (!this.$common.isEmpty(newVal) && !regex.test(newVal)) {
        return callback(new Error('请输入数字'));
      }
      this.$common.strMaxVerify(rule, value, callback);
    },
    // 向对应语言的复杂描述插入尺码模板
    insetDescription(data) {
      if (this.$common.isEmpty(this.descriptionBOJson[data.tabName])) return;
      let divDemo = document.createElement('div');
      divDemo.id = `${data.tableId}-content`;
      divDemo.style.position = 'absolute';
      divDemo.style.zIndex = '-10';
      divDemo.style.width = '100vw';
      divDemo.style.height = '100vh';
      divDemo.style.top = '100vh';
      divDemo.innerHTML = this.descriptionBOJson[data.tabName].description;
      document.body.appendChild(divDemo);
      this.$nextTick(() => {
        const tableHtml = divDemo.querySelector(`#${data.tableId}`);
        if (tableHtml) {
          tableHtml.remove();
          this.descriptionBOJson[data.tabName].description = divDemo.innerHTML + data.html;
        } else {
          this.descriptionBOJson[data.tabName].description += data.html;
        }
        divDemo.remove();
        if (this.langActiveTab == data.tabName && this.descActiveTab == 'description') {
          // 插入描述
          this.editor.setContent(this.descriptionBOJson[this.langActiveTab].description);
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.product-upload-list {
  width: 200px;
  height: 200px;
}

.custom-tag-input {
  line-height: normal;
  border: 1px solid #dddee1;
  border-radius: 4px;
  padding: 0 0 0 0;
}

.product-upload-list-cover i {
  margin: 0 6px;
}

.classify_style {
  :deep(.ivu-form-item-label) {
    &:before {
      content: "*";
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 14px;
      color: #ed4014;
    }
  }
}

.box100 {
  width: 100px;
  height: 100px;
}

.box200 {
  width: 200px;
  height: 200px;
}

.box500 {
  width: 500px;
  height: 500px;
}

.attrForm {
  :deep(.ivu-form-item-label) {
    padding-left: 25px;
  }
}
.gpsr-tips-icon{
  .ivu-icon {
    font-size: 20px;
    color: #f20;
  }
}
.inputValue {
  display: inline-block;
  width: 160px;
}

.formItemLeft {
  width: 480px;

  :deep(.ivu-form-item-label) {
    padding-left: 10px;
  }
}

.bgContent {
  :deep(.ivu-form-item-label) {
    padding-left: 10px;
  }
}

.bottomBtn {
  display: flex;
  padding: 10px;
  flex-direction: row-reverse;
}

.tabs-textmaterial {
  position: relative;

  :deep(.tabs-btnpos) {
    position: absolute;
    top: 10px;
    right: 20px;
  }
}

.editPage {
  position: absolute;
  width: 100%;
  height: calc(100vh - 95px);
  top: 0;
  left: 0;
  background: #fff;
  overflow: hidden;
  z-index: 9;

  :deep(.edit-page-form) {
    height: calc(100% - 42px);
    overflow: auto;
    &.ivu-form {
      .ivu-form-item-label {
        padding: 10px 5px 10px 0;
      }
    }
  }

  :deep(.ivu-select) {
    text-align: left;
  }
  :deep(.accessory-style) {
    .upload-contain{
      display: inline-block;
      width: 85px;
      vertical-align: top;
    }
    .uploaded-file-list{
      display: inline-block;
      max-width: calc(100% - 85px);
      vertical-align: top;
      .uploaded-file-item{
        display: inline-block;
        width: auto;
        &:hover{
          background: none;
          color: #2d8cf0;
        }
        .file-title{
          width: auto;
          max-width: initial;
          vertical-align: middle;
          text-decoration: underline;
          color: #2d8cf0;
        }
        .remove-uploaded-file{
          display: inline-block;
          vertical-align: middle;
          i {
            color: #f20;
          }
        }
      }
    }
  }
}

.topBtn {
  position: sticky;
  display: flex;
  justify-content: space-between;
  top: 0;
  width: 100%;
  text-align: right;
  background: #fff;
  z-index: 9999;
  box-shadow: 0px 1px 5px #bbb;

  .top-tags {
    height: 42px;
  }

  .head-tabs {
    height: 100%;

    .ivu-radio-group {
      height: 100%;

      .ivu-radio-wrapper {
        height: 42px;
        line-height: 42px;
        border: none;

        &.ivu-radio-wrapper-checked {
          color: #fff;
          background: #2d8cf0;
          border-radius: 0;
        }

        &:before {
          content: '';
          display: none;
        }
      }
    }
  }

  .top-buttons {
    margin: 5px;
    padding: 0 10px;
  }
}

.form-item-flex-wrap {
  display: flex;
  flex-flow: row wrap;

  .ivu-form-item {
    width: 33.33%;
    min-width: 300px;
  }
}

.display-flex {
  display: flex;

  .flex-30 {
    flex: 30;
  }

  .flex-70 {
    flex: 70;
  }
}

.products-content {
  &.purchase-content {
    display: flex;
    flex-flow: wrap;

    :deep(.ivu-form-item) {
      padding-left: 15px;
      width: 25%;
      min-width: 300px;
      max-width: 450px;
    }
  }
}
.tag-comtent-item{
  height: 100%;
  overflow: auto;
}
.washable-max-pic-view{
  max-width: 500px;
  max-height: 400px;
}
.washable-label-view {
  display: flex;
  align-items: center;
  min-height: 32px;
  line-height: 0;
  .washable-pic-view{
    max-width: 60px;
    max-height: 40px;
    cursor: pointer;
  }
  .washable-pdf-view{
    line-height: 1.2em;
    span{
      cursor: pointer;
      color: #57a3f3;
      text-decoration: underline;
      text-underline-offset: 3px;
    }
  }
}
</style>
<style lang="less">
.custom-tag-input .ivu-input {
  border: none;
  height: 30px;
}

.custom-tag-input .ivu-input:focus {
  border-color: red;
  border: none;
  box-shadow: none;
}

.custom-tag-input .ivu-input:hover {
  border-color: red;
  border: none;
}

.custom-tag-input .ivu-tag {
  word-break: break-all;
  height: auto;
}

.productsCont {
  background-color: #fff;
  border: 1px solid #d7dde4;

  .sizeChartTable {

    .ivu-table td,
    .ivu-table th {
      border-bottom: 1px solid #e8eaec;
      border-left: 1px solid #e8eaec;
    }

    .ivu-table td:last-child,
    .ivu-table th:last-child {
      border-right: 1px solid #e8eaec;
    }
  }
}

.products-content {
  .important-attribute {
    .ivu-form-item-label {
      color: #f20;
      font-weight: bold;
    }
  }
}

.click-text-underline {
  display: inline-block;
  position: relative;
  padding: 0px 5px;
  cursor: pointer;
  color: #57a3f3;
  text-decoration: underline;
  text-underline-offset: 3px;

  &.click-text-disabled {
    color: #f3f3f3;
    cursor: no-drop;
  }
}

.text-translate-5 {
  transform: translate(0, -5px);
}

.washed-operate {
  display: flex;

  .washed-image-content {
    position: relative;
    width: 60px;
    height: 60px;
    box-shadow: 0 0 5px #ccc;
    border-radius: 5px;

    img {
      cursor: pointer;
      height: 100%;
      width: 100%;
    }
  }

  .washed-image-preview-content {
    position: relative;

    img {
      max-width: 600px;
      max-height: 600px;
      min-width: 200px;
    }
  }
}

/* SKU 多语言图片弹框样式 */
.sku-img-modal-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  border-bottom: 1px solid #e8eaec;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.sku-img-tab {
  padding: 4px 12px;
  border-radius: 3px;
  font-size: 13px;
  cursor: pointer;
  color: #515a6e;
  border: 1px solid #dcdfe6;
  position: relative;
  user-select: none;
}
.sku-img-tab.active {
  background: #2d8cf0;
  color: #fff;
  border-color: #2d8cf0;
}
.sku-img-tab-count {
  display: inline-block;
  font-style: normal;
  background: #ed4014;
  color: #fff;
  font-size: 11px;
  border-radius: 8px;
  padding: 0 4px;
  margin-left: 3px;
  line-height: 1.5;
}
.sku-img-modal-sync-bar {
  display: flex;
  align-items: center;
  padding: 6px 0 10px;
  font-size: 13px;
  color: #515a6e;
  border-bottom: 1px dashed #e8eaec;
  margin-bottom: 10px;
}
.sku-img-modal-suite {
  min-height: 140px;
  padding: 6px 0 4px;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  margin-bottom: 12px;
  padding: 10px;
}
/* 图套标签栏 */
.sku-img-set-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 6px;
}
.sku-img-set-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
}
.sku-img-set-tag {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  font-size: 13px;
  cursor: pointer;
  color: #515a6e;
  user-select: none;
  background: #fff;
}
.sku-img-set-tag.active {
  border-color: #2d8cf0;
  color: #2d8cf0;
  background: #e8f4ff;
  font-weight: 600;
}
.sku-set-type-badge {
  display: inline-block;
  font-style: normal;
  font-size: 11px;
  padding: 0 5px;
  border-radius: 10px;
  margin-left: 5px;
  background: #19be6b;
  color: #fff;
  line-height: 1.6;
}
.sku-img-add-set-btn {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border: 1px dashed #2d8cf0;
  border-radius: 3px;
  color: #2d8cf0;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
  background: #fff;
  flex-shrink: 0;
}
.sku-img-add-set-btn:hover {
  background: #e8f4ff;
}
/* 图套图片内容区 */
.sku-img-set-content {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 108px;
  align-items: flex-start;
}
.sku-img-no-set-tip {
  width: 100%;
  padding: 20px 0;
  text-align: center;
  color: #bbb;
  font-size: 13px;
}
/* 删除图套链接 */
.sku-img-set-del-bar {
  text-align: right;
  margin-top: 6px;
}
.sku-img-del-set-link {
  color: #ed4014;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}
.sku-img-del-set-link:hover {
  opacity: 0.75;
}
/* 编辑图套链接 */
.sku-img-edit-set-link {
  color: #2d8cf0;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}
.sku-img-edit-set-link:hover {
  opacity: 0.75;
}
/* 新增/编辑图套弹框内容 */
.sku-add-set-modal-body {
  padding: 4px 8px 0;
}
.sku-add-set-row {
  margin-bottom: 18px;
}
.sku-add-set-label {
  display: block;
  font-size: 13px;
  color: #17233d;
  font-weight: 600;
  margin-bottom: 8px;
}
.sku-add-set-input {
  width: 100%;
}
.sku-add-set-err {
  color: #ed4014;
  font-size: 12px;
  margin-top: 4px;
}
.sku-add-set-type-list {
  display: flex;
  gap: 16px;
}
.sku-set-type-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  font-size: 13px;
  color: #515a6e;
}
.sku-set-type-radio {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 2px solid #dcdfe6;
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
  transition: border-color 0.2s;
}
.sku-set-type-option.active .sku-set-type-radio {
  border-color: #2d8cf0;
}
.sku-set-type-radio-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2d8cf0;
}
.sku-set-type-badge-lg {
  display: inline-block;
  font-style: normal;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 10px;
  color: #fff;
  line-height: 1.6;
  font-weight: 600;
}
.sku-add-set-footer {
  text-align: right;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
  margin-top: 4px;
}
.sku-img-modal-spu {
  padding: 4px 0 8px;
}
.sku-img-modal-spu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #17233d;
}
.sku-img-spu-lang-filter {
  display: flex;
  gap: 4px;
}
.spu-filter-tag {
  padding: 1px 7px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
  color: #515a6e;
  user-select: none;
}
.spu-filter-tag.active {
  border-color: #2d8cf0;
  color: #2d8cf0;
  background: #e8f4ff;
}
.sku-img-modal-spu-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-height: 96px;
  padding: 4px;
  background: #f8f8f8;
  border-radius: 4px;
}
</style>
